<template>
<div class="chapter">
<div class="inner_page">
<div>
<h2 class="toctitle"><i>Addresses of Music Publishers</i></h2>
<p class="body-textb">A bracketed number (e.g., <b>[1])</b> following the name of a publisher corresponds to that of its American agent, distributor, or parent company (see preceding listing, “American Agents, Distributors, or Parent Companies of Music Publishers”). <b>Bold print</b> has been added to help the reader find items in the alphabetical sequence. In cases where no information about a publisher was found, the last known address is given. Readers are encouraged to bear in mind that addresses frequently change and that these can often be checked on the worldwide web or through the Music Publishers Association of the United States (<a href="http://www.mpa.org" target="_blank">www.mpa.org</a>).</p>
<p class="body-textb"> </p>
<p class="body-textb1"><b>Academia Brasileira de Música</b></p>
<p class="hangb1">Rua da Lapa<br/>120/12° andar<br/>20021-180 Rio de Janeiro, Brazil<br/>Tel/Fax: (21) 2292-5845<br/><a href="http://www.abmusica.org.br" target="_blank">www.abmusica.org.br</a></p>
<p class="body-textb1"><b>Acanthus</b> Music</p>
<p class="hangb1">Postfach<br/>4522 Rüttenen SO, Switzerland<br/>Tel: (41) 32-637-06-30<br/>Fax: (41) 32-637-06-31<br/><a href="http://www.acanthus-music.ch" target="_blank">www.acanthus-music.ch</a></p>
<p class="body-textb1">Edizioni Giuseppe <b>Accardi</b></p>
<p class="hangb1">Rotterdam, The Netherlands<br/>c/o Musica Repartita<br/>Goedestraat 133<br/>3572 RS Utrecht<br/>The Netherlands<br/>Tel: (31) 30-718465</p>
<p class="body-textb1"><b>Accent</b> Music <b>[18]</b></p>
<p class="body-textb1"><b>Adeva</b> Musik (<i>see</i> Bärenreiter)</p>
<p class="body-textb1"><b>Aenear</b> Publishing Co.</p>
<p class="hangb1">Toronto, Canada</p>
<p class="body-textb1"><b>Africanus</b> Editions</p>
<p class="hangb1">3126 Shenandoah Avenue<br/>St. Louis, MO 63104<br/>Tel: (314) 773-8769</p>
<p class="body-textb1"><b>Ahn &amp; Simrock</b></p>
<p class="hangb1">Hamburg, Germany<br/><a href="http://www.theaterverlagmuenchen.de/as_allg.php" target="_blank">www.theaterverlagmuenchen.de/as_allg.php</a></p>
<p class="body-textb1"><b>Akkord</b> Music Publishers <b>[6]</b></p>
<p class="hangb1">Barackos út 28/a<br/>1224 Budapest, Hungary<br/>Fax: (36) 1-207-4767<br/><a href="http://www.akkordmusic.hu" target="_blank">www.akkordmusic.hu</a></p>
<p class="body-textb1"><b>Alacran</b> Press</p>
<p class="hangb1">695 Wrelton Drive<br/>San Diego, CA 92109</p>
<p class="body-textb1"><b>Albersen</b> Muziek</p>
<p class="hangb1">Valeriusstraat 12<br/>2517 HR Den Haag<br/>The Netherlands<br/>Tel: (31) 70-345-6000<br/>Fax: (31) 70-345-71-10<br/><a href="http://www.albersen.nl" target="_blank">www.albersen.nl</a></p>
<p class="body-textb1">J. <b>Albert</b> (<i>see</i> E. B. Marks)</p>
<p class="body-textb1"><b>Allans</b> Music Australia <b>[6]</b></p>
<p class="body-textb1"><b>ALMA</b> (Association for Latin-American</p>
<p class="hangb1">Music and Art)<br/>10985 West Broward Blvd.<br/>Plantation, FL 33324<br/>Tel: (888) 275-2562<br/>Fax: (954) 915-9144<br/><a href="http://www.alma-usa.com" target="_blank">www.alma-usa.com</a></p>
<p class="body-textb1"><b>Alpeg</b> Editions <b>[14]</b></p>
<p class="body-textb1"><b>Alsbach [17]</b></p>
<p class="body-textb1"><b>Amadeus [8, 10, 17]</b></p>
<p class="hangb1">Hermannstrasse 7<br/>8400 Winterthur, Switzerland<br/>Tel: (41) 52-233-28-66<br/>Fax: (41) 52-233-54-01<br/><a href="http://www.amadeusmusic.ch" target="_blank">www.amadeusmusic.ch</a></p>
<p class="body-textb1"><b>American Composers Alliance:</b></p>
<p class="hangb1">Composers Facsimile Edition<br/>802 W. 190th Street 1st Floor<br/>New York, NY 10040<br/>Tel: (212) 925-0458<br/>Fax: (212) 925-6798<br/><a href="http://www.composers.com" target="_blank">www.composers.com</a></p>
<p class="body-textb1"><b>American Composers Forum</b></p>
<p class="hangb1">332 Minnesota Street, Suite East 145<br/>St. Paul, MN 55101-1300<br/>Tel: (651) 228-1407<br/>Fax: (651) 291-7978<br/><a href="http://www.composersforum.org" target="_blank">www.composersforum.org</a></p>
<p class="body-textb1"><b>American Institute of Musicology</b></p>
<p class="hangb1">(includes The Corpus of Early Music Keyboard Music)<br/>c/o Tempo Music Publications<br/>3773 W. 95th Street<br/>Leawood, KS 66206<br/>Tel: (913) 381-5088 or (800) 733-5066<br/>Fax: (913) 381-5081<br/><a href="http://www.tempomusic.com/aim" target="_blank">www.tempomusic.com/aim</a></p>
<p class="body-textb1"><b>American Music Center</b> (<i>see</i> New Music USA)</p>
<p class="body-textb1"><b>American Music Editions</b></p>
<p class="hangb1">263 East 7th Street<br/>New York, NY 10009-6049<br/>Fax: (212) 420-9393<br/><i>Archive:</i><br/>Northwestern University Library<br/>1970 Campus Drive<br/>Evanston, Illinois 60208-2300<br/>Tel: (847) 491-7658<br/><a href="http://www.library.northwestern.edu/libraries-collections/evanston-campus/music-library/collections/special-collections/american-music" target="_blank">www.library.northwestern.edu/libraries-collections/evanston-campus/music-library/collections/special-collections/american-music</a></p> <p class="body-textb1">Gli <b>Amici della Musica da Camera</b></p>
<p class="hangb1">Via Bocca di Leone 25<br/>Rome, Italy</p>
<p class="body-textb1"><b>Amphion</b> Éditions Musicales <b>[10]</b></p>
<p class="body-textb1"><b>AMS</b> Press</p>
<p class="hangb1">Brooklyn Navy Yard<br/>63 Flushing Avenue, Unit #221<br/>Brooklyn, NY 11205-1073<br/>Fax: (718) 875-3800<br/><a href="http://www.amspressinc.com" target="_blank">www.amspressinc.com</a></p>
<p class="body-textb1"><b>Amsco</b> School Publishing <b>[13]</b></p>
<p class="hangb1">315 Hudson Street<br/>New York, NY 10013-1085</p>
<p class="hangb1">Tel: (800) 969-8398 or (212) 886-6500</p>
<p class="hangb1">Fax: (212) 886-6515<br/><a href="http://amscopub.com" target="_blank">amscopub.com</a></p>
<p class="body-textb1">Johann <b>André</b></p>
<p class="hangb1">Frankfurterstrasse 28</p>
<p class="hangb1">63065 Offenbach, Germany</p>
<p class="hangb1">Tel: (49) 69-813539</p>
<p class="hangb1">Fax: (49) 69-815339<br/><a href="http://www.musik-andre.de" target="_blank">www.musik-andre.de</a></p>
<p class="body-textb1"><b>Andromeda</b> Editrice <b>[10]</b></p>
<p class="hangb1">64042 Colledara (Te), Italy</p>
<p class="hangb1">Tel: (39) 861-699014</p>
<p class="hangb1">Fax: (39) 861-699000<br/><a href="http://www.organisti.it/andromeda.htm" target="_blank">www.organisti.it/andromeda.htm</a></p>
<p class="body-textb1"><b>Anglican [6]</b></p>
<p class="body-textb1"><b>A-R</b> Editions <b>[6]</b></p>
<p class="hangb1">8551 Research Way, Suite 180<br/>Middleton, WI 5356</p>
<p class="hangb1">Tel: (608) 836-9000 or (800) 736-0070</p>
<p class="hangb1">Fax: (608) 831-8200<br/><a href="http://www.areditions.com" target="_blank">www.areditions.com</a></p>
<p class="body-textb1"><b>A-Ram</b> Edition</p>
<p class="hangb1">Moscow, Russia</p>
<p class="body-textb1"><b>Arbeitsgemeinschaft der Eigenverleger</b></p>
<p class="hangb1">Lasserstraße 6</p>
<p class="hangb1">5020 Salzburg, Austria</p>
<p class="hangb1">Tel: (66) 2-78-86-84</p>
<p class="body-textb1">Groupe <b>Archambault</b></p>
<p class="hangb1">500 Est, Rue Ste-Catherine Montreal<br/>Quebec, H2L 2C6 Canada</p>
<p class="hangb1">Tel: (514) 849-6201</p>
<p class="hangb1">Fax: (514) 849-1481</p>
<p class="body-textb1"><b>Ariadne</b> Verlag</p>
<p class="hangb1">Geibelgasse 14</p>
<p class="hangb1">1150 Vienna, Austria</p>
<p class="hangb1">Tel: (43) 1-8953255</p>
<p class="hangb1">Fax: (43) 1-8953244-20<br/><a href="http://www.ariadne-verlag.com" target="_blank">www.ariadne-verlag.com</a></p>
<p class="body-textb1">Collecion <b>Arion [18]</b></p>
<p class="body-textb1"><b>Armelin</b> Musica</p>
<p class="hangb1">Via dei Soncin, 42</p>
<p class="hangb1">35122 Padova, Italy</p>
<p class="hangb1">Tel: (39) 49-8724-928</p>
<p class="hangb1">Fax: (39) 49-8736-524<br/><a href="http://www.armelin.it" target="_blank">www.armelin.it</a></p>
<p class="body-textb1"><b>Arno Press [18]</b></p>
<p class="body-textb1"><b>Arno Volk Verlag</b> (<i>see</i> Universal Music Publishing Group)</p>
<p class="body-textb1"><b>Arrow</b> Music Press <b>[13, 17]</b></p>
<p class="body-textb1"><b>Ars Viva</b> Verlag <b>[17]</b></p>
<p class="hangb1">Weihergarten 5</p>
<p class="hangb1">55116 Mainz, Germany</p>
<p class="hangb1">Tel: (49) 6131-2460</p>
<p class="hangb1">Fax: (49) 6131-246-211</p>
<p class="body-textb1"><b>Arsis</b> Press</p>
<p class="hangb1">c/o Empire Publishing Service</p>
<p class="hangb1">P.O. Box 1344<br/>Studio City, CA 91614</p>
<p class="hangb1">Tel: (818) 784-8918</p>
<p class="hangb1">Fax: (818) 990-2477<br/><a href="http://www.arsispress.com" target="_blank">www.arsispress.com</a></p>
<p class="body-textb1"><b>Art Publication of St. Louis [18]</b></p>
<p class="body-textb1"><b>Artia [2, 8, 12]</b></p>
<p class="hangb1">Prague, Czech Republic</p>
<p class="body-textb1"><b>Ascherberg, Hopwood &amp; Crew,</b> Ltd.</p>
<p class="hangb1">Music Publishers<br/>c/o Chappell International Music<br/>Publ. Group Ltd.<br/>50 New Bond Street<br/>London W1A 2BR, United Kingdom</p>
<p class="body-textb1">Edwin <b>Ashdown [6, 16, 17]</b></p>
<p class="body-textb1"><b>Ashley</b> Dealers Service <b>[18]</b></p>
<p class="body-textb1">Hermann <b>Assmann</b> Musikverlag</p>
<p class="hangb1">Franz-Werfel-Strasse 3660431<br/>Frankfurt 50, Germany</p>
<p class="hangb1">Tel: (49-69) 532431/526231</p>
<p class="body-textb1"><b>Associated Board of the Royal School of Music [14, 15]</b></p>
<p class="hangb1">24 Portland Place<br/>London W1B 1LU<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 20-7636-5400</p>
<p class="hangb1">Fax: (44) 20-7637-0234<br/><a href="http://www.abrsm.org" target="_blank">www.abrsm.org</a></p>
<p class="body-textb1"><b>Associated Music Publishers [10, 13, 16, 17]</b> (part of Music Sales Group)</p>
<p class="hangb1">New York, NY</p>
<p class="body-textb1"><b>Astoria</b> Verlag</p>
<p class="hangb1">Weihergarten 5</p>
<p class="hangb1">55116 Mainz, Germany</p>
<p class="hangb1">Tel: (49) 6131-246-889</p>
<p class="hangb1">Fax: (49) 6131-246-250<br/><a href="http://www.astoria-verlag.de" target="_blank">www.astoria-verlag.de</a></p>
<p class="body-textb1"><b>Augener [5]</b></p>
<p class="body-textb1"><b>Australian Music Centre</b></p>
<p class="hangb1">P.O. Box N690<br/>Grosvenor Place<br/>Sydney NSW 1220, Australia</p>
<p class="hangb1">Tel: (61) 2-9247-4677</p>
<p class="hangb1">Fax: (61) 2-9241-2873<br/><a href="http://www.amcoz.com.au/amc" target="_blank">www.amcoz.com.au/amc</a></p>
<p class="body-textb1"><b>Authors Agency of the Polish Music Publishers</b></p>
<p class="hangb1">ul. Hipteczna 2,<br/>00-950 Warsaw, Poland</p>
<p class="body-textb1"><b>Autographus Musicus</b></p>
<p class="hangb1">Årdalavägen158</p>
<p class="hangb1">12432 Bandhagen, Sweden</p>
<p class="body-textb1"><b>Axelrod [18]</b></p>
<p class="body-textb1">Musica <b>Baltica [14, 17]</b></p>
<p class="hangb1">Kr. Barona 39-1<br/>Riga 1011, Latvia</p>
<p class="hangb1">Tel: (371) 67-275575</p>
<p class="hangb1">Fax: (371) 67-272755<br/><a href="http://www.musicabaltica.com" target="_blank">www.musicabaltica.com</a></p>
<p class="body-textb1"><b>Banks</b> Music <b>[13, 17]</b></p>
<p class="hangb1">The Granary, Wath Court<br/>Hovingham, York YO62 4NN<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 1653-628545</p>
<p class="hangb1">Fax: (44) 1653-627214<br/><a href="http://www.banksmusicpublications.co.uk" target="_blank">www.banksmusicpublications.co.uk</a></p>
<p class="body-textb1"><b>Bardic</b> Edition <b>[17]</b></p>
<p class="hangb1">6 Fairfax Crescent<br/>Aylesbury, Bucks HP20 2ES<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) (1296) 428609</p>
<p class="hangb1">U.S. Tel: (914) 816-1137</p>
<p class="hangb1">Fax: (44) (1296) 581185<br/><a href="http://www.bardic-music.com" target="_blank">www.bardic-music.com</a></p>
<p class="body-textb1"><b>Bärenreiter</b> Verlag <b>[4, 6, 8, 13, 15, 17]</b></p>
<p class="hangb1">(works of Schoenberg dist. in U.S. by Belmont)</p>
<p class="hangb1">Heinrich-Schütz-Allee 35-37<br/>34131 Kassel, Germany</p>
<p class="hangb1">Tel: (49) 561-3105-0</p>
<p class="hangb1">Fax: (49) 561-3105-240<br/><a href="http://www.baerenreiter.com/nc/en/" target="_blank">www.baerenreiter.com/nc/en/</a></p>
<p class="body-textb1">Editio <b>Bärenreiter Praha</b></p>
<p class="hangb1">namestri Jiriho z Podebrad 112/19<br/>130 00 Prague 3, Czech Republic</p>
<p class="hangb1">Tel: (420) 274-001-911</p>
<p class="hangb1">Fax: (420) 222-220-829<br/><a href="http://www.ebp.cz" target="_blank">www.ebp.cz</a></p>
<p class="body-textb1"><b>Barry [13, 17]</b></p>
<p class="hangb1">Buenos Aires, Argentina</p>
<p class="body-textb1"><b>Bartók Records</b> and Publications</p>
<p class="hangb1">P.O. Box 399<br/>Homosassa, FL 34487</p>
<p class="hangb1">Tel: (352) 382-2015</p>
<p class="hangb1">Fax: (352) 382-0341<br/><a href="http://www.bartokrecords.com" target="_blank">www.bartokrecords.com</a></p>
<p class="body-textb1">M. P. <b>Belaieff [13, 17]</b></p>
<p class="hangb1">Mainz, Germany<br/><a href="http://www.belaieff-music.com" target="_blank">www.belaieff-music.com</a></p>
<p class="body-textb1"><b>Belmont</b> Music Publishers <b>[6, 17]</b></p>
<p class="hangb1">1221 Bienveneda Avenue<br/>Pacific Palisades, CA 90272</p>
<p class="hangb1">Tel: (310) 454-1867</p>
<p class="hangb1">Fax: (310) 573-1925<br/><a href="http://www.schoenbergmusic.com" target="_blank">www.schoenbergmusic.com</a></p>
<p class="body-textb1"><b>Belwin-Mills [1, 6, 13, 17]</b></p>
<p class="body-textb1"><b>Berandol</b> Music Ltd. (Canada) <b>[6, 11, 17]</b></p>
<p class="hangb1">P.O. Box 45059</p>
<p class="hangb1">81 Lakeshore Road E.<br/>Mississauga, ON L5G 2X4, Canada</p>
<p class="hangb1">Tel: (877) 356-1002 or (905) 278-6338</p>
<p class="hangb1">Fax: (905) 278-9409<br/><a href="http://www.berandolmusic.com" target="_blank">www.berandolmusic.com</a></p>
<p class="body-textb1">Edizioni <b>Bèrben [13, 15, 17]</b></p>
<p class="hangb1">Via Redipuglia 65</p>
<p class="hangb1">60122 Ancona, Italy</p>
<p class="hangb1">Tel: (39) 71-204428</p>
<p class="hangb1">Fax: (39) 71-57414<br/><a href="http://www.berben.it" target="_blank">www.berben.it</a></p>
<p class="body-textb1">Edição <b>Bevilacqua [18]</b></p>
<p class="hangb1">Rio de Janeiro, Brazil</p>
<p class="body-textb1"><b>Biblioteca Central [18]</b></p>
<p class="hangb1">Sección de Música<br/>Barcelona, Spain</p>
<p class="body-textb1"><b>Biedermann [18]</b></p>
<p class="body-textb1">Gerald <b>Billaudot,</b> Editeur/Editions</p>
<p class="hangb1">Billaudot <b>[6, 13, 15, 17]</b><br/>14, Rue de l'Échiquier<br/>75010 Paris, France</p>
<p class="hangb1">Tel: (33) 1-47-70-14-46</p>
<p class="hangb1">Fax: (33) 1-45-23-22-54<br/><a href="http://www.billaudot.com" target="_blank">www.billaudot.com</a></p>
<p class="body-textb1"><b>Black Cat</b> Productions</p>
<p class="hangb1">10808 124th Street<br/>Edmonton, AB, T5M 0H4, Canada</p>
<p class="hangb1">Tel: (800) 661-3613</p>
<p class="hangb1">Fax: (780) 447-5337</p>
<p class="body-textb1"><b>BMI Canada,</b> Ltd. <b>[18]</b></p>
<p class="body-textb1"><b>Boccaccini e Spada [13, 15, 17]</b></p>
<p class="hangb1">Via Arezzo 17</p>
<p class="hangb1">00040 Pavona di Albano Laziale<br/>(Rome), Italy</p>
<p class="hangb1">Tel: (39) 6-9310217 or (39) 6-9310561</p>
<p class="hangb1">Fax: (39) 6-9311903<br/>Email: <a href="mailto:bsmusica@tiscalinet.it">bsmusica@tiscalinet.it</a></p>
<p class="body-textb1">Fred <b>Bock [10, 13]</b></p>
<p class="hangb1">P.O. Box 570567<br/>Tarzana, CA 91357</p>
<p class="hangb1">Tel: (818) 996-6181</p>
<p class="hangb1">Fax: (818) 996-2043<br/><a href="http://www.fredbock.com" target="_blank">www.fredbock.com</a></p>
<p class="body-textb1"><b>Boelke-Bomart</b> Music Publications (<i>see</i> Jerona Music Corp.)</p>
<p class="body-textb1"><b>Bolamar</b> Ediciones Musicales</p>
<p class="hangb1">Azor, 5 (Molino de la Hoz)<br/>28232 Las Rozas (Madrid), Spain</p>
<p class="hangb1">Fax: (34) 916303643<br/><a href="http://www.bolamar.net" target="_blank">www.bolamar.net</a></p>
<p class="body-textb1"><b>Bomart</b> (<i>see</i> Boelke-Bomart)</p>
<p class="body-textb1"><b>Bongiovanni</b> Francesco Edizioni Musicali</p>
<p class="hangb1">Via Ugo Bassi, 31/F<br/>40121 Bologna, Italy</p>
<p class="hangb1">Tel: (39) 51-22-57-22</p>
<p class="hangb1">Fax: (39) 51-22-61-28</p>
<p class="body-textb1">Joseph <b>Boonin</b> (<i>see</i> Jerona Music Corp.)</p>
<p class="body-textb1"><b>Bosse</b> Edition <b>[6, 17]</b></p>
<p class="hangb1">Postfach 417</p>
<p class="hangb1">84 Regensburg 2, Germany</p>
<p class="body-textb1"><b>Boston</b> Music <b>[13, 15, 17]</b></p>
<p class="body-textb1"><b>Bosworth</b> &amp; Co. <b>[3, 6, 10, 17]</b></p>
<p class="body-textb1"><b>Bote &amp; Bock [6, 10, 13, 17]</b></p>
<p class="hangb1">Berlin, Germany</p>
<p class="body-textb1"><b>Bourne</b> Company <b>[6, 17]</b></p>
<p class="hangb1">5 West 37th Street, 6th Floor<br/>New York, NY 10018</p>
<p class="hangb1">Tel: (212) 391-4300</p>
<p class="hangb1">Fax: (212) 391-4306<br/><a href="http://www.bournemusic.com" target="_blank">www.bournemusic.com</a></p>
<p class="body-textb1"><b>Bowdoin College</b> Music Press</p>
<p class="hangb1">Bowdoin College<br/>Brunswick, ME 04011<br/><a href="http://www.library.bowdoin.edu/arch/archives/bcmpg.shtml" target="_blank">www.library.bowdoin.edu/arch/archives/bcmpg.shtml</a></p>
<p class="body-textb1">The <b>Boxwood</b> Press</p>
<p class="hangb1">183 Ocean View Blvd.<br/>Pacific Grove, CA 93950</p>
<p class="hangb1">Tel: (408) 375-9110</p>
<p class="body-textb1"><b>Bradley</b> Publications <b>[1]</b> (formerly through CPP/Belwin Music)</p>
<p class="body-textb1"><b>Branden</b> Publishing</p>
<p class="hangb1">Div. of Branden Books</p>
<p class="hangb1">P.O. Box 812094<br/>Wellesley, MA 02482<br/><a href="http://www.brandenbooks.com" target="_blank">www.brandenbooks.com</a></p>
<p class="body-textb1"><b>Bratti [18]</b></p>
<p class="body-textb1"><b>Brazilian Music</b> Enterprises <b>[18]</b></p>
<p class="body-textb1"><b>Breitkopf &amp; Härtel [6, 8, 13, 15, 17]</b></p>
<p class="hangb1">Walkmühlstraße 52</p>
<p class="hangb1">65195 Wiesbaden, Germany</p>
<p class="hangb1">Tel: (49) 611-45008-0</p>
<p class="hangb1">Fax: (49) 611-45008 59-61<br/><a href="http://www.breitkopf.com" target="_blank">www.breitkopf.com</a></p>
<p class="body-textb1">The <b>British Library</b> Publishing Office</p>
<p class="hangb1">96 Euston Road<br/>London NW1 2DB<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 20-7412-7704<br/><a href="http://www.publishing.bl.uk" target="_blank">www.publishing.bl.uk</a><br/><b>distributed in the U.S. &amp; Canada by</b><br/>University of Chicago Press<br/>1427 E. 60th Street<br/>Chicago, IL 60637</p>
<p class="hangb1">Tel: (773) 702-7248</p>
<p class="hangb1">Fax: (773) 702-9756<br/><a href="http://www.press.uchicago.edu" target="_blank">www.press.uchicago.edu</a></p>
<p class="body-textb1"><b>Broadbent &amp; Dunn [13, 17]</b></p>
<p class="hangb1">66 Nursery Lane<br/>Dover, Kent, CT16 3EX<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 1304-825604<br/><a href="http://www.broadbent-dunn.com" target="_blank">www.broadbent-dunn.com</a></p>
<p class="body-textb1"><b>Broadcast Music,</b> Inc.</p>
<p class="hangb1">10 Music Square East<br/>Nashville, TN 37203-4399</p>
<p class="hangb1">Tel: (615) 401-2000<br/><a href="http://www.bmi.com" target="_blank">www.bmi.com</a></p>
<p class="body-textb1"><b>Broekmans &amp; Van Poppel [6]</b></p>
<p class="hangb1">Van Baerlestraat 92-94<br/>1071 BB Amsterdam<br/>The Netherlands</p>
<p class="hangb1">Tel: (31) 20-679-65-75 or 20-659-72-70</p>
<p class="hangb1">Fax: (31) 20-664-67-59<br/><a href="http://www.broekmans.com" target="_blank">www.broekmans.com</a></p>
<p class="body-textb1">Dr. J. <b>Butz</b> Musikverlag</p>
<p class="hangb1">Postfach 30 09 54</p>
<p class="hangb1">53189 Bonn, Germany</p>
<p class="hangb1">Tel: (49) 228-946-949-24<br/><a href="http://www.butz-verlag.de" target="_blank">www.butz-verlag.de</a></p>
<p class="body-textb1"><b>Cambria</b> Publishing <b>[17, 18]</b></p>
<p class="body-textb1"><b>Cambridge University Press</b></p>
<p class="hangb1">32 Avenue of the Americas<br/>New York, NY 10013</p>
<p class="hangb1">Tel: (212) 337-5000 or (845) 353-7500<br/>(customer service)<br/><a href="http://www.cambridge.org" target="_blank">www.cambridge.org</a></p>
<p class="body-textb1"><b>Canadian Music Centre</b></p>
<p class="hangb1">20 St. Joseph Street<br/>Toronto, Ontario M4Y 1J9, Canada</p>
<p class="hangb1">Tel: (416) 961-6601</p>
<p class="hangb1">Fax: (416) 961-7198<br/><a href="http://www.musiccentre.ca" target="_blank">www.musiccentre.ca</a></p>
<p class="body-textb1"><b>Cantext</b> Music</p>
<p class="hangb1">19 Laval Drive</p>
<p class="hangb1">Winnipeg R3T 2XB, Canada</p>
<p class="hangb1">Tel: (204) 275-1598</p>
<p class="body-textb1"><b>Canyon</b> Press <b>[18]</b></p>
<p class="body-textb1"><b>Carisch,</b> S.P.A. <b>[2, 6, 13, 17]</b></p>
<p class="hangb1">Via Canova 55</p>
<p class="hangb1">20020 Lainate, Italy<br/><a href="http://www.carisch.com" target="_blank">www.carisch.com</a></p>
<p class="body-textb1"><b>Carlanita</b> Music Co. <b>[10, 13, 16, 17]</b></p>
<p class="hangb1">P.O. Box 698, Cathedral Station<br/>New York, NY 10025</p>
<p class="body-textb1">Edizioni <b>Carrara</b></p>
<p class="hangb1">Via A. da Calepio, 4</p>
<p class="hangb1">24125 Bergamo, Italy</p>
<p class="hangb1">Tel: (39) 35-243618</p>
<p class="hangb1">Fax: (39) 35-270298<br/><a href="http://www.edizionicarrara.it" target="_blank">www.edizionicarrara.it</a></p>
<p class="body-textb1"><b>Carus</b>-Verlag <b>[6, 13, 15, 17]</b></p>
<p class="hangb1">Sielminger Str. 51</p>
<p class="hangb1">70771 LE-Echterdingen, Germany</p>
<p class="hangb1">Tel: (49) 711-797-330-0</p>
<p class="hangb1">Fax: (49) 711-797-330-29<br/><a href="http://www.carus-verlag.com" target="_blank">www.carus-verlag.com</a></p>
<p class="body-textb1">Valentim de <b>Carvalho</b></p>
<p class="hangb1">Estrada de Paço de Arcos, 26<br/>2770-129 Paço de Arcos, Portugal</p>
<p class="hangb1">Tel: (351) 214-401-000</p>
<p class="hangb1">Fax: (351) 214-401-095<br/><a href="http://www.valentim.pt" target="_blank">www.valentim.pt</a></p>
<p class="body-textb1"><b>Casa Amarilla</b></p>
<p class="hangb1">Santiago, Chile</p>
<p class="hangb1">Tel: (56) 2-698-3483<br/><a href="http://www.casamarilla.cl" target="_blank">www.casamarilla.cl</a></p>
<p class="body-textb1">Casa <b>Iriberri [18]</b></p>
<p class="hangb1">Buenos Aires, Argentina</p>
<p class="body-textb1"><b>Casia</b> Publishing <b>[7]</b></p>
<p class="body-textb1"><b>Catamount</b> Facsimile Editions (<i>see</i> American Composers Alliance)</p>
<p class="body-textb1"><b>Caveat</b> Music Publishers</p>
<p class="hangb1">c/o E.C. Kerby Itd.<br/>198 Davenport Road<br/>Toronto M5R 1J2, Canada</p>
<p class="hangb1">Tel: (416) 922-9934</p>
<p class="body-textb1"><b>CeBeDeM</b> (Centre Belge de Documentation Musicale)<b>[6]</b></p>
<p class="hangb1">Avenue du port 86c bte 214</p>
<p class="hangb1">1000 Brussels, Belgium</p>
<p class="hangb1">Tel: (32) 2-230-94-30</p>
<p class="hangb1">Fax: (32) 2-230-94-37<br/><a href="http://www.cebedem.be" target="_blank">www.cebedem.be</a></p>
<p class="body-textb1"><b>Century</b> Music Publishing Co. (<i>see</i> Ashley Dealers)</p>
<p class="body-textb1">Le <b>Chant du Monde [6, 7, 13, 17]</b></p>
<p class="hangb1">31-33 Rue Vandrezanne<br/>75013 Paris, France</p>
<p class="hangb1">Tel: (33) 1-53-80-12-30</p>
<p class="hangb1">Fax: (33) 1-53-80-12-18<br/><a href="http://www.chantdumonde.com" target="_blank">www.chantdumonde.com</a></p>
<p class="body-textb1"><b>Chappell</b> &amp; Co. <b>[1, 10, 13]</b> (<i>see</i> Warner/Chappel Music)</p>
<p class="body-textb1"><b>Cherry Lane</b> Music Co. <b>[10, 13, 17]</b></p>
<p class="hangb1">10 Midland Avenue<br/>Port Chester, NY 10573</p>
<p class="hangb1">Tel: (914) 935-5200</p>
<p class="hangb1">Fax: (914) 937-0614<br/><a href="http://www.cherrylane.mseek.net" target="_blank">www.cherrylane.mseek.net</a></p>
<p class="body-textb1"><b>Chesky Hudebni Fond</b></p>
<p class="hangb1">Český rozhlas<br/>Římská 13</p>
<p class="hangb1">120 99 Prague, Czech Republic</p>
<p class="hangb1">Tel: (420) 221-553-361</p>
<p class="hangb1">Fax: (420) 221-553-355<br/><a href="http://www.hudebnifond.cz" target="_blank">www.hudebnifond.cz</a></p>
<p class="body-textb1">J. W. <b>Chester [16]</b> (<i>see</i> Chester Music below)</p>
<p class="body-textb1"><b>Chester</b> Music <b>[10, 13, 17]</b> (now part of Music Sales Group)</p>
<p class="hangb1">14-15 Berners Street<br/>London W1T 3LJ<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 20-7612-7400</p>
<p class="hangb1">Fax: (44) 20-7612-7545<br/><a href="http://www.chesternovello.com" target="_blank">www.chesternovello.com</a></p>
<p class="body-textb1"><b>Chiarato</b> &amp; Cia. <b>[18]</b></p>
<p class="hangb1">São Paulo, Brazil</p>
<p class="hangb1">Editions <b>Choudens [16, 17]</b> (now part of Music Sales Group)</p>
<p class="hangb1">Paris, France</p>
<p class="body-textb1"><b>Chromattica [18]</b></p>
<p class="body-textb1"><b>Chronos</b> Music (absorbed by Cormorant Press; <i>see</i> Cormorant Press)</p>
<p class="body-textb1">John <b>Church</b> Company <b>[18]</b> (no longer in business)</p>
<p class="body-textb1">Andrea <b>Coen-Zanibon [6]</b></p>
<p class="body-textb1">Franco <b>Colombo [18]</b></p>
<p class="body-textb1"><b>Columbia Music Company [13, 15, 17]</b></p>
<p class="hangb1"><a href="http://www.comusco.com" target="_blank">www.comusco.com</a></p>
<p class="body-textb1"><b>Columbia University Press</b></p>
<p class="hangb1">61 West 62nd Street</p>
<p class="hangb1">New York, NY 10023</p>
<p class="hangb1"><a href="http://www.cc.columbia.edu/cu/cup" target="_blank">www.cc.columbia.edu/cu/cup</a></p>
<p class="hangb1">Tel: (212) 459-0600 or (800) 343-4499</p>
<p class="hangb1">(Perseus Dist.)</p>
<p class="hangb1">Fax: (212) 459-3678 (sales)</p>
<p class="hangb1"><a href="http://www.cup.columbia.edu" target="_blank">www.cup.columbia.edu</a></p>
<p class="body-textb1"><b>Composer/Performer Edition</b></p>
<p class="hangb1">330 University Avenue<br/>Davis, CA 95616</p>
<p class="body-textb1"><b>Composers Library</b> Editions <b>[7, 13, 15, 17]</b></p>
<p class="body-textb1"><b>Composers</b> Press (<i>see</i> Seesaw Music Corp.) <b>[17]</b></p>
<p class="body-textb1"><b>Compozitor</b> Publishing House</p>
<p class="hangb1">Bolshaya Morskaya St., 45</p>
<p class="hangb1">190000 St. Petersburg, Russia<br/>Tel/Fax: (7) 812-314-50-54<br/><a href="http://www.compozitor.spb.ru/eng" target="_blank">www.compozitor.spb.ru/eng</a></p>
<p class="body-textb1"><b>Concordia</b> Publishing House <b>[17]</b></p>
<p class="hangb1">3558 S. Jefferson St.<br/>St. Louis, MO 63118</p>
<p class="hangb1">Tel: (314) 268-1000 or (800) 325-3040</p>
<p class="hangb1">Fax: (800) 490-9889<br/><a href="http://www.cph.org" target="_blank">www.cph.org</a></p>
<p class="body-textb1"><b>Conners</b> Publications</p>
<p class="hangb1">503 Tahoe Street<br/>Natchitoches, LA 71457-5718</p>
<p class="hangb1">Tel: (318) 357-0924<br/><a href="http://www.music-usa.org/conners" target="_blank">www.music-usa.org/conners</a></p>
<p class="body-textb1"><b>Consolidated</b> Music Publishers (part of Music Sales Corp.)</p>
<p class="hangb1">257 Park Avenue South, 20th Floor<br/>New York, NY 10010</p>
<p class="hangb1">Tel: (212) 254-2100</p>
<p class="hangb1">Fax: (212) 254-2013<br/><a href="http://www.schirmer.com" target="_blank">www.schirmer.com</a></p>
<p class="body-textb1">The <b>Consort</b> Press <b>[17]</b></p>
<p class="hangb1">1273 S. Rice Road, #8<br/>Ojai, CA 93023</p>
<p class="hangb1">Tel: (805) 646-4779<br/><a href="http://www.consortpress.com" target="_blank">www.consortpress.com</a></p>
<p class="body-textb1"><b>Continuo</b> Music Press <b>[18]</b></p>
<p class="body-textb1"><b>Copa [18]</b></p>
<p class="body-textb1"><b>Cormorant Press [18]</b></p>
<p class="body-textb1"><b>Cornetto</b></p>
<p class="hangb1">Hummelgasse 4</p>
<p class="hangb1">70378 Stuttgart, Germany</p>
<p class="hangb1">Tel: (49) 711-9561396</p>
<p class="hangb1">Fax: (49) 711-9561-397<br/><a href="http://www.cornetto-music.de" target="_blank">www.cornetto-music.de</a></p>
<p class="body-textb1">J. B. <b>Cramer</b> &amp; Co., Ltd. <b>[2, 13, 17]</b></p>
<p class="body-textb1"><b>Cranz [3, 17]</b></p>
<p class="body-textb1"><b>Creazioni Artistiche Musicali</b> (C.A.M.)</p>
<p class="hangb1">Via Cola di Rienzo, 152</p>
<p class="hangb1">00192 Rome, Italy</p>
<p class="hangb1">Tel: (39) (6) 6840791</p>
<p class="hangb1">Fax: (39) (6) 6874046</p>
<p class="body-textb1"><b>Crescendo</b> Publishing Co.</p>
<p class="hangb1">Tel: (888) 602-8466<br/><a href="http://www.crescendopublishing.com/" target="_blank">www.crescendopublishing.com/</a></p>
<p class="body-textb1"><b>Crystal Spring</b> Music Publishers</p>
<p class="hangb1">250 Ohua Avenue, 10E<br/>Honolulu, HI 96815</p>
<p class="hangb1">Tel: (808) 923-6859</p>
<p class="body-textb1"><b>Culver Crest</b> Publications</p>
<p class="hangb1">P.O. Box 4484<br/>Culver City, CA 90231-4484<br/>Tel/Fax: (310) 838-4465<br/><a href="http://www.culvercrest.com/Culver_Crest_Publications" target="_blank">www.culvercrest.com/Culver_Crest_Publications</a></p>
<p class="body-textb1">Edizioni <b>Curci [6]</b></p>
<p class="hangb1">Galleria del Corso, 4</p>
<p class="hangb1">20122 Milano, Italy</p>
<p class="hangb1">Tel: (39) 2-76-03-61</p>
<p class="hangb1">Fax: (39) 2-76-01-45-04<br/><a href="http://www.edizionicurci.it" target="_blank">www.edizionicurci.it</a></p>
<p class="body-textb1"><b>Currency Press</b> Pty Ltd.</p>
<p class="hangb1"><i>Street address:</i> 164 James Street<br/>Redfern NSW 2016, Australia<br/>M<i>ailing address:</i> P.O. Box 2287<br/>Strawberry Hills 2012 NSW Australia</p>
<p class="hangb1">Tel: (61) (2) 9319-5877</p>
<p class="hangb1">Fax: (61) (2) 9319-3649<br/><a href="http://www.currency.com.au" target="_blank">www.currency.com.au</a></p>
<p class="body-textb1">J. <b>Curwen</b> &amp; Son (England) <b>[6, 10, 16, 17]</b></p>
<p class="body-textb1"><b>Czech State Music [18]</b></p>
<p class="body-textb1"><b>Da Capo</b> Press <b>[17]</b> (part of Perseus Books Group)</p>
<p class="hangb1">44 Farnsworth Street, 3rd Floor<br/>Boston, MA 02210</p>
<p class="hangb1">Tel: (617) 252-5200 or<br/>(800) 343-4499 (orders)</p>
<p class="hangb1">Fax: (800) 351-5073 (orders)<br/><a href="http://www.perseusbooksgroup.com/dacapo" target="_blank">www.perseusbooksgroup.com/dacapo</a></p>
<p class="body-textb1"><b>Dantalian,</b> Inc.</p>
<p class="hangb1">11 Pembroke Street<br/>Newton, MA 02458<br/>Tel/Fax: (617) 244-7230<br/><a href="http://www.dantalian.com" target="_blank">www.dantalian.com</a></p>
<p class="body-textb1"><b>De Ring [18]</b></p>
<p class="body-textb1">Edizioni <b>de Santis</b></p>
<p class="hangb1">Viale Mazzini 6</p>
<p class="hangb1">00195 Rome, Italy</p>
<p class="body-textb1"><b>Deep Listening</b> Publications</p>
<p class="hangb1">P.O. Box 1956<br/>Kingston, NY 12402</p>
<p class="hangb1">Tel: (914) 338-5984<br/><a href="http://www.deeplistening.org" target="_blank">www.deeplistening.org</a></p>
<p class="body-textb1">Georges <b>Delrieu [5, 6, 17]</b></p>
<p class="hangb1">11, Rue de Paris<br/>06000 Nice, France</p>
<p class="hangb1">Tel: (33) 4-93-88-61-96<br/><a href="http://www.georgesdelrieu.com" target="_blank">www.georgesdelrieu.com</a></p>
<p class="body-textb1"><b>Derry</b> Music Co.</p>
<p class="hangb1">221 Main Street, Suite 440<br/>San Francisco, CA 94105</p>
<p class="hangb1">Tel: (415) 537-9640</p>
<p class="body-textb1"><b>Desforges [18]</b></p>
<p class="hangb1">Le Havre, France</p>
<p class="body-textb1"><b>Deutscher Verlag für Musik</b></p>
<p class="hangb1">Leipzig, Germany</p>
<p class="body-textb1"><b>DGR</b> Publishers (name changed to Seda Publications; <i>see</i> Seda Publications)</p>
<p class="body-textb1">Oliver <b>Ditson</b> Company <b>[15]</b> (a subsdiary of TP)</p>
<p class="hangb1"><a href="http://www.presser.com" target="_blank">www.presser.com</a></p>
<p class="body-textb1">Les Éditions <b>Doberman-Yppan [6, 17]</b></p>
<p class="hangb1">2220, Chemin du Fleuve<br/>Saint-Romuald, QC<br/>G6W 1Y4 Canada</p>
<p class="hangb1">Tel: (418) 834-8384</p>
<p class="hangb1">Fax: (418) 834-3522<br/><a href="http://www.dobermaneditions.com" target="_blank">www.dobermaneditions.com</a></p>
<p class="body-textb1">Ludwig <b>Doblinger [6, 8, 13, 17]</b></p>
<p class="body-textb1">Edition <b>Dohr [17]</b></p>
<p class="hangb1">Sindorfer Straße 19<br/>50127 Bergheim, Germany</p>
<p class="hangb1">Tel: (49) 2271-70-72-05/06</p>
<p class="hangb1">Fax: (49) 2271-70-72-07<br/><a href="http://www.dohr.de" target="_blank">www.dohr.de</a></p>
<p class="body-textb1"><b>Donemus</b> Publishing <b>[6, 13, 15, 17]</b></p>
<p class="hangb1">Amsterdam, The Netherlands</p>
<p class="hangb1">Tel: 6-4520-5176<br/><a href="http://www.donemus.nl" target="_blank">www.donemus.nl</a></p>
<p class="body-textb1">Edition <b>Donna [18]</b></p>
<p class="hangb1">Düsseldorf, German</p>
<p class="body-textb1"><b>Dotesio</b> (Spain) (<i>see</i> Union Musical Española)</p>
<p class="body-textb1"><b>Dover</b> Publications <b>[1, 8, 13, 17]</b></p>
<p class="hangb1">31 East Second Street</p>
<p class="hangb1">Mineola, NY 11501-3582</p>
<p class="hangb1">Tel: (800) 223-3130 or (516) 294-7000</p>
<p class="hangb1">Fax: (516) 742-6953<br/><a href="http://www.doverpublications.com" target="_blank">www.doverpublications.com</a></p>
<p class="body-textb1"><b>Dreililien</b> Verlag</p>
<p class="hangb1">Richard Birnbach<br/>Aubinger Strasse 9</p>
<p class="hangb1">82166 Gräfelfing, Germany</p>
<p class="hangb1">Tel: (49-89) 875450</p>
<p class="body-textb1">L. K. <b>Drew</b> Publishing</p>
<p class="hangb1">303 Orton Road<br/>Yellow Springs, OH 45387</p>
<p class="hangb1">Tel: (937) 767-9383</p>
<p class="body-textb1"><b>Duma</b> Music</p>
<p class="hangb1">557 Barron Avenue<br/>Woodbridge, NJ 07095</p>
<p class="hangb1">Tel: (732) 636-5406</p>
<p class="hangb1">Fax: (732) 636-5220<br/><a href="http://www.dumamusic.com" target="_blank">www.dumamusic.com</a></p>
<p class="body-textb1"><b>Durand Costallat [13, 15, 17]</b></p>
<p class="body-textb1"><b>Durand [2, 6, 8, 10, 13, 17]</b></p>
<p class="hangb1">Paris, France</p>
<p class="hangb1"><a href="http://www.durand-salabert-eschig.com" target="_blank">www.durand-salabert-eschig.com</a></p>
<p class="body-textb1"><b>Eastman School of Music</b> Publications</p>
<p class="hangb1">26 Gibbs Street<br/>Rochester, NY 14604</p>
<p class="hangb1">Tel: (585) 274-1000<br/><a href="http://www.esm.rochester.edu" target="_blank">www.esm.rochester.edu</a></p>
<p class="body-textb1"><b>Ediciones Musicales</b></p>
<p class="hangb1">Campanario No. 315<br/>Havana, Cuba</p>
<p class="body-textb1"><b>Editio Musica Budapest (EMB) [2, 6, 13, 15; 21,</b> New Liszt Edition only]</p>
<p class="hangb1">P.O. Box 322</p>
<p class="hangb1">1370 Budapest, Hungary</p>
<p class="hangb1">Tel: (36) 1-2361-104</p>
<p class="hangb1">Fax: (36) 1-2361-101<br/><a href="http://www.emb.hu" target="_blank">www.emb.hu</a></p>
<p class="body-textb1">Edition <b>Chroma</b></p>
<p class="hangb1">P.O. Box 816<br/>Duncan, BC V9L 3Y2<br/>Canada</p>
<p class="body-textb1">Edition <b>Gravis</b></p>
<p class="hangb1">Grabbeallee 15</p>
<p class="hangb1">13156 Berlin, Germany</p>
<p class="hangb1">Tel: (49) 30-61-69-81-0</p>
<p class="hangb1">Fax: (49) 30-61-69-81-21<br/><a href="http://www.editiongravis.de" target="_blank">www.editiongravis.de</a></p>
<p class="body-textb1">Edition <b>Modern [18]</b></p>
<p class="body-textb1">Edition <b>Nordstern</b></p>
<p class="hangb1">Spitzwegstr. 17</p>
<p class="hangb1">70192 Stuttgart, Germany</p>
<p class="hangb1">Tel: (49) 711-8179106<br/><a href="http://www.edno.de" target="_blank">www.edno.de</a></p>
<p class="body-textb1">Edition <b>Pan [11]</b></p>
<p class="body-textb1"><b>Edition Russe de Musique [18]</b></p>
<p class="body-textb1">Edition <b>Tympanon</b></p>
<p class="hangb1">Karl-Heinz Schickhaus<br/>Markt 52<br/>4271 St. Oswald b. Fr., Austria</p>
<p class="hangb1">Tel: (43) 79-45-81-10</p>
<p class="body-textb1">Les Éditions <b>Bleu Blanc Rouge</b> (<i>see</i> Hansen House)</p>
<p class="body-textb1"><b>Éditions d'Etat pour la Littérature et l'Art [18]</b></p>
<p class="hangb1">Bucharest, Rumania</p>
<p class="body-textb1">Éditions de la <b>Sirène Musicale [18]</b> Paris, France</p>
<p class="body-textb1"><b>Éditions du Centre de Musique Baroque de Versailles</b></p>
<p class="hangb1">Hôtel des Menus Plaisirs<br/>22, Avenue de Paris<br/>78003 Versailles Cedex, France</p>
<p class="hangb1">Tel: (33) 1-39-20-78-10</p>
<p class="hangb1">Fax: (33) 1-39-20-78-01<br/><a href="http://www.cmbv.fr/Recherche-UMR/Activites-scientifiques/Editions-musicologiques" target="_blank">http://www.cmbv.fr/Recherche-UMR/Activites-scientifiques/Editions-musicologiques</a></p>
<p class="body-textb1">Éditions Musicales de la <b>Schola Cantorum</b></p>
<p class="hangb1">et de la Procure Générale de Musique &amp;<br/>Labatiaz (<i>see</i> Labatiaz)</p>
<p class="body-textb1">Éditions Musicales <b>des Marais</b> (<i>see</i> Editions Jobert)</p>
<p class="body-textb1">Éditions Musicales <b>Transatlantiques [13, 17]</b></p>
<p class="body-textb1">Éditions Ray <b>Ventura [18]</b></p>
<p class="hangb1">Paris, France</p>
<p class="body-textb1">Éditions <b>Rideau Rouge [10]</b></p>
<p class="body-textb1">Editions <b>Romanos [17]</b></p>
<p class="hangb1">3 Michael Koutsofta str.</p>
<p class="hangb1">P.O. Box 56202</p>
<p class="hangb1">3305 Limassol, Cyprus</p>
<p class="hangb1">Tel: (357) 92-46-024</p>
<p class="hangb1">Fax: (357) 92-41-362</p>
<p class="body-textb1"><b>Editions 75</b></p>
<p class="hangb1">75, Rue de la Roquette<br/>75011 Paris, France</p>
<p class="hangb1">Tel: (33) 1-43-48-90-57</p>
<p class="hangb1">Fax: (33) 1-43-48-85-74<br/><a href="http://www.editions75.com" target="_blank">www.editions75.com</a></p>
<p class="body-textb1"><b>Editorial Argentina</b> de Música <b>[18]</b></p>
<p class="body-textb1"><b>Editorial Cooperativa Interamericana de Compositores [18]</b></p>
<p class="body-textb1">Editorial de Música <b>Boileau [6, 17]</b></p>
<p class="hangb1">c/ Provença, 287</p>
<p class="hangb1">08037 Barcelona, Spain</p>
<p class="hangb1">Tel: (34) 93-487-74-56 or<br/>(34) 93-215-53-34</p>
<p class="hangb1">Fax: (34) 93-215-53-34<br/><a href="http://www.boileau-music.com" target="_blank">www.boileau-music.com</a></p>
<p class="body-textb1">Editorial de <b>Música Española Contemporánea</b></p>
<p class="hangb1">Alcalá, 70</p>
<p class="hangb1">28009 Madrid, Spain</p>
<p class="hangb1">Tel: (34-91) 5770752</p>
<p class="hangb1">Fax: (34) (91) 5757645</p>
<p class="body-textb1">Editorial <b>Politonia [18]</b></p>
<p class="hangb1">Buenos Aires, Argentina</p>
<p class="body-textb1">Editura de Stat <b>Pentru</b> Literatura si Arta</p>
<p class="hangb1">(<i>see</i> Editura Eminescu)</p>
<p class="body-textb1">Editura <b>Eminescu</b></p>
<p class="hangb1">Piata Presei Libere nr.1, corp C, et. 3,<br/>cam. 360</p>
<p class="hangb1">Sector 1, Bucurest, Romania<br/>Tel/Fax: (40) 31-805-8938<br/><a href="http://www.edituraeminescu.ro" target="_blank">www.edituraeminescu.ro</a></p>
<p class="body-textb1">Edizioni <b>Curci</b></p>
<p class="hangb1">Galleria del Corso, 4</p>
<p class="hangb1">20122 Milano, Italy<br/><a href="http://www.edizionicurci.it" target="_blank">www.edizionicurci.it</a></p>
<p class="body-textb1"><b>Elkan &amp; Schildknecht</b></p>
<p class="hangb1">Emil Carelius AB<br/>Kungsholmsgatan 15</p>
<p class="hangb1">112 27 Stockholm, Sweden</p>
<p class="hangb1">Tel: (46) 8-6515421</p>
<p class="body-textb1"><b>Elkan-Vogel [15]</b> (a subsidiary of T. Presser)</p>
<p class="hangb1"><a href="http://www.presser.com" target="_blank">www.presser.com</a></p>
<p class="body-textb1">William <b>Elkin</b> Music Services [In U.S., <i>see</i> <b>6]</b></p>
<p class="hangb1">Elkin Music International<br/>Station Road Industrial Estate Salhouse<br/>Norwich NR13 6NS, United Kingdom</p>
<p class="hangb1">Tel: (44-1603) 721302</p>
<p class="hangb1">Fax: (44-1603) 721801</p>
<p class="body-textb1"><b>Engström &amp; Södring</b> (Denmark) <b>[18]</b></p>
<p class="body-textb1"><b>Enoch</b> &amp; Cie <b>[6, 13]</b></p>
<p class="body-textb1"><b>Eres</b> Edition</p>
<p class="hangb1">Horst Schubert<br/>Hauptstraße 35</p>
<p class="hangb1">28865 Lilienthal, Germany</p>
<p class="hangb1">Tel: (49) 04298-1676</p>
<p class="hangb1">Fax: (49) 04298-5312<br/><a href="http://www.eres-musik.de" target="_blank">www.eres-musik.de</a></p>
<p class="body-textb1"><b>Erviti</b></p>
<p class="hangb1">San Martin, 28 bajo<br/>20.005 San Sebastian, Spain</p>
<p class="hangb1">Tel: (34) 943-30-04-93</p>
<p class="hangb1">Fax: (34) 943-20-03-43</p>
<p class="body-textb1">Max <b>Eschig [2, 6, 10, 13, 17]</b></p>
<p class="hangb1">Paris, France</p>
<p class="hangb1"><a href="http://www.durand-salabert-eschig.com" target="_blank">www.durand-salabert-eschig.com</a></p>
<p class="body-textb1"><b>Euganea</b> Editoriale Comunicazioni</p>
<p class="hangb1">Via Cernaia, 84</p>
<p class="hangb1">35142 Padova, Italy</p>
<p class="hangb1">Tel: (39) 049657493</p>
<p class="body-textb1"><b>Eulenburg</b> (Schott Music) <b>[6, 8, 13, 17]</b></p>
<p class="body-textb1"><b>European American</b> Music Distributors Corp. and European American Retail Music <b>[13, 17]</b></p>
<p class="body-textb1"><b>Excelsior</b> Music Publishing <b>[13, 15, 17]</b></p>
<p class="body-textb1"><b>Faber</b> Music <b>[1, 6, 10, 13, 17]</b></p>
<p class="body-textb1"><b>Fairfield,</b> Ltd. (<i>see</i> Novello)</p>
<p class="body-textb1">Manuel de <b>Falla</b> Ediciones <b>[6, 13, 17]</b></p>
<p class="hangb1">S.L. C/ Breton de los Herreros, 55-Bajo F<br/>28003 Madrid, Spain</p>
<p class="hangb1">Tel: (34-91) 441-77-43</p>
<p class="hangb1">Fax: (34-91) 442-60-96<br/><a href="http://www.manueldefallaediciones.es" target="_blank">www.manueldefallaediciones.es</a></p>
<p class="body-textb1"><b>Fallen Leaf Press</b> (<i>see</i> J. W. Pepper)</p>
<p class="hangb1">P.O. Box 10034<br/>Berkeley, CA 94709<br/>Tel/Fax: (510) 848-7805<br/><a href="http://www.fallenleaf.com" target="_blank">www.fallenleaf.com</a></p>
<p class="body-textb1">Musik <b>Fabrik [6, 17]</b></p>
<p class="hangb1">18, Rue Marthe Aureau<br/>77400 Lagny-sur-Marne, France<br/>Tel/Fax: (33) 1-73-58-50-59<br/><a href="http://www.classicalmusicnow.com" target="_blank">www.classicalmusicnow.com</a></p>
<p class="body-textb1">Edition <b>Fazer [6, 13, 17]</b></p>
<p class="body-textb1"><b>FEMA</b> Music Publications <b>[</b>out of business<b>]</b></p>
<p class="body-textb1"><b>Fentone</b> Music (England) <b>[6, 13, 17]</b></p>
<p class="body-textb1"><b>Finnish Information Centre</b></p>
<p class="hangb1">Lauttasaarentie 1</p>
<p class="hangb1">00200 Helsinki, Finland</p>
<p class="hangb1">Tel: (358) 9-68101313</p>
<p class="hangb1">Fax: (358) 9-682-0070<br/><a href="http://www.fimic.fi" target="_blank">www.fimic.fi</a></p>
<p class="body-textb1">J. <b>Fisher</b> &amp; Bro. <b>[18]</b></p>
<p class="body-textb1"><b>FJH</b> Music Company <b>[17]</b></p>
<p class="hangb1">2525 Davie Road, Suite 360<br/>Fort Lauderdale, FL 33317-7424</p>
<p class="hangb1">Tel: (800) 262-8744 or (954) 382-6061</p>
<p class="hangb1">Fax: (954) 382-3073<br/><a href="http://www.fjhmusic.com" target="_blank">www.fjhmusic.com</a></p>
<p class="body-textb1"><b>FLP</b> Music Publishing</p>
<p class="hangb1">P.O. Box 60806<br/>Oklahoma City, OK 73146<br/>(Does business by mail only.)</p>
<p class="body-textb1">La <b>Flûte de Pan</b></p>
<p class="hangb1">59, Rue de Rome (Piano scores)<br/>75008 Paris, France</p>
<p class="hangb1">Tel: (33) 1-42-93-47-82<br/><a href="http://www.laflutedepan.com" target="_blank">www.laflutedepan.com</a></p>
<p class="body-textb1"><b>Foetisch</b> Frères, S.A. <b>[7, 17]</b></p>
<p class="hangb1">Lausanne, Switzerland</p>
<p class="body-textb1">Charles <b>Foley,</b> Inc. <b>[18]</b></p>
<p class="body-textb1">Fondazione <b>Carminignani Rossini [18]</b></p>
<p class="hangb1">Pesaro, Italy</p>
<p class="body-textb1">Fondazione <b>Eugenio Bravi [18]</b> Milan, Italy</p>
<p class="body-textb1"><b>Forberg [14, 17]</b></p>
<p class="body-textb1">A. <b>Forlivesi [6]</b></p>
<p class="hangb1">Via Stelloni 3/A<br/>40010 Sala Bolognese BO, Italy<br/>Tel: (39) 51-6814142/98</p>
<p class="hangb1">Fax: (39) 51-6814672<br/><a href="http://www.forlivesi.it" target="_blank">www.forlivesi.it</a></p>
<p class="body-textb1">Arnaldo <b>Forni,</b> Editore</p>
<p class="hangb1">Via Gramsci 164<br/>40010 Sala Bologna, Italy</p>
<p class="hangb1">Tel: (39-51) 95-41-42 / 95-41-98</p>
<p class="hangb1">Fax: (39-51) 95-46-72<br/><a href="http://www.fornieditore.com" target="_blank">www.fornieditore.com</a></p>
<p class="body-textb1"><b>Forsyth Brothers [6, 17]</b></p>
<p class="hangb1">126 Deansgate<br/>Manchester M3 2GR<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 161-956-2052</p>
<p class="hangb1">Fax: (44) 161-834-0630<br/><a href="http://www.forsyths.co.uk" target="_blank">www.forsyths.co.uk</a></p>
<p class="body-textb1">Sam <b>Fox</b> Music Sales <b>[15]</b> (<i>see</i> Warner/Chappell)</p>
<p class="body-textb1"><b>Frangipani</b> Press <b>[1]</b></p>
<p class="body-textb1"><b>Frank</b> Music Corporation <b>[10]</b></p>
<p class="body-textb1"><b>Fredonia</b> Press Discs</p>
<p class="hangb1">3947 Fredonia Drive<br/>Los Angeles, CA 90068<br/>Tel: (323) 851-3043</p>
<p class="body-textb1">H. <b>Freeman</b> &amp; Company <b>[18]</b></p>
<p class="body-textb1"><b>Frog Peak</b> Music</p>
<p class="hangb1">Box 1052<br/>Lebanon, NH 03766<br/>Tel/Fax: (603) 643-9037<br/><a href="http://www.frogpeak.org" target="_blank">www.frogpeak.org</a></p>
<p class="body-textb1"><b>Fromont [18]</b></p>
<p class="body-textb1">Theodore <b>Front</b> Music Literature</p>
<p class="hangb1">6122 Cohasset Street<br/>Van Nuys, CA 91406-2989</p>
<p class="hangb1">Tel: (818) 994-1902</p>
<p class="hangb1">Fax: (818) 994-0419<br/><a href="http://www.tfront.com" target="_blank">www.tfront.com</a></p>
<p class="body-textb1"><b>Fujihara</b> Music Company <b>[6]</b></p>
<p class="body-textb1"><b>Furore</b> Verlag <b>[6, 17]</b></p>
<p class="hangb1">Naumberger Straße 40</p>
<p class="hangb1">34127 Kassel, Germany</p>
<p class="hangb1">Tel: (49) 561-500-493-11</p>
<p class="hangb1">Fax: (49) 561-500-493-20<br/><a href="http://www.furore-verlag.de" target="_blank">www.furore-verlag.de</a></p>
<p class="body-textb1">Adolph <b>Fürstner [13]</b></p>
<p class="body-textb1"><b>Galaxy</b> Music Corp. <b>[5, 17]</b></p>
<p class="body-textb1"><b>Galliard,</b> Ltd. (England) <b>[5]</b></p>
<p class="body-textb1"><b>Garland</b> Publishing <b>[6]</b></p>
<p class="hangb1">270 Madison Avenue #4<br/>New York, NY 10016</p>
<p class="hangb1">Tel: (917) 315-7100</p>
<p class="body-textb1">Carl <b>Gehrmans</b> Musikförlag <b>[2, 6]</b></p>
<p class="hangb1">P.O. Box 42026</p>
<p class="hangb1">126 12 Stockholm, Sweden</p>
<p class="hangb1">Tel: (46) 8-6100-600<br/><a href="http://www.gehrmans.se" target="_blank">www.gehrmans.se</a></p>
<p class="body-textb1"><b>General Music Publishing</b> (<i>see</i> Boston Music Company)</p>
<p class="body-textb1"><b>General Words and Music [18]</b></p>
<p class="body-textb1">Daniel <b>Gerard</b> Publications</p>
<p class="hangb1">5 Plain Avenue<br/>New Rochelle, NY<br/>Tel: (914) 235-2525</p>
<p class="body-textb1">Musikverlag Hans <b>Gerig [18]</b></p>
<p class="body-textb1"><b>Girard [18]</b></p>
<p class="hangb1">Naples, Italy</p>
<p class="body-textb1"><b>Glocken</b> Verlag <b>[17]</b></p>
<p class="hangb1">12-14 Mortimer Street<br/>London WIT 3JJ<br/>United Kingdom</p>
<p class="body-textb1"><b>Goldberg</b> Ediçôes Musicais</p>
<p class="hangb1">Rua S. Vicente 360 ap A<br/>Porto Alegre (Rio Grande do Sul)<br/>Brazil<br/>Tel: (51) 3388-87-46</p>
<p class="body-textb1"><b>Greenwood Press</b></p>
<p class="hangb1">World Library Publications<br/>2145 Central Parkway<br/>Cincinnati, OH 45214</p>
<p class="body-textb1"><b>Gregg International</b></p>
<p class="hangb1">White Swan Ho<br/>Godstone, Surrey RH9 8LW<br/>United Kingdom</p>
<p class="hangb1">Tel: (44-1883) 744214</p>
<p class="hangb1">Fax: (44-1883) 744024</p>
<p class="body-textb1">Henri <b>Gregh</b></p>
<p class="hangb1">129, rue Montmartre<br/>Paris, France</p>
<p class="body-textb1">Grupo <b>Renovación [18]</b></p>
<p class="hangb1">Buenos Aires, Argentina</p>
<p class="body-textb1"><b>GSP Music</b></p>
<p class="hangb1">230 Townsend Street<br/>San Francisco, CA 94107-1720</p>
<p class="hangb1">Tel: (415) 896-1144<br/><a href="http://www.gspguitar.com" target="_blank">www.gspguitar.com</a></p>
<p class="body-textb1"><b>Gulbenkian Foundation</b></p>
<p class="hangb1">Parque de Sta. Gertrudes à Avda. de<br/>Berna</p>
<p class="hangb1">Lisbon, Portugal<br/></p>
<p class="body-textb1">Wolfgang G. <b>Haas</b>-Musikverlag</p>
<p class="hangb1">Postfach 90 07 48<br/>Köln, Germany</p>
<p class="hangb1">Tel: (49) 2203-98-88-3-50</p>
<p class="hangb1">Fax: (49) 2203-98-88-3-50<br/><a href="http://www.haas-koeln.de" target="_blank">www.haas-koeln.de</a></p>
<p class="body-textb1">G. K. <b>Hall</b> &amp; Co.</p>
<p class="hangb1">c/o Simon &amp; Schuster <b>[13]</b><br/>200 Old Tappan Road<br/>Old Tappan, NJ 07675-7095</p>
<p class="hangb1">Tel: (800) 257-5157</p>
<p class="hangb1">Fax: (800) 558-4676<br/><a href="http://www.simonandschuster.com" target="_blank">www.simonandschuster.com</a></p>
<p class="body-textb1"><b>Hamelle [13, 15, 17]</b> (<i>see</i> Leduc)</p>
<p class="hangb1">Paris, France</p>
<p class="body-textb1"><b>Hansen House</b> Music <b>[6]</b></p>
<p class="hangb1">1820 West Avenue<br/>Miami Beach, FL 33139</p>
<p class="hangb1">Tel: (305) 532-5461</p>
<p class="hangb1">Fax: (305) 672-8729<br/><a href="http://www.hansenhousemusic.com" target="_blank">www.hansenhousemusic.com</a></p>
<p class="body-textb1">Wilhelm <b>Hansen [6, 10, 13, 16, 17]</b></p>
<p class="hangb1">Bornholmsgade 1A<br/>1266 Copenhagan K, Denmark<br/>Tel: (45) 33-11-78-88</p>
<p class="hangb1">Fax: (45) 33-14-81-78<br/><a href="http://www.ewh.dk" target="_blank">www.ewh.dk</a></p>
<p class="body-textb1"><b>Hänssler</b> (<i>see</i> American Institute of Musicology) <b>[17]</b></p>
<p class="body-textb1"><b>Hargail</b> Music Press <b>[11]</b></p>
<p class="body-textb1"><b>Harmonia Uitgave [17]</b></p>
<p class="hangb1">Roeltjesweg 23-25<br/>Hilversum, Netherlands</p>
<p class="body-textb1">Frederick <b>Harris</b> Music Co. <b>[6]</b></p>
<p class="hangb1">(Distributed in the U.S. by FJH Music Company. <i>See</i> FJH.) Suite 882</p>
<p class="hangb1">60 Industrial Parkway<br/>Cheektowaga, NY 14227</p>
<p class="hangb1">Tel: (800) 387-4013</p>
<p class="hangb1">Fax: (416) 408-1542<br/><a href="http://www.frederickharrismusic.com" target="_blank">www.frederickharrismusic.com</a></p>
<p class="body-textb1"><b>Harvard University Press</b></p>
<p class="hangb1">79 Garden Street<br/>Cambridge, MA 02138-1499</p>
<p class="hangb1">Tel: (800) 448-2242 or (617) 495-2600</p>
<p class="hangb1">Fax: (617) 495-5898<br/><a href="http://www.hup.harvard.edu" target="_blank">www.hup.harvard.edu</a></p>
<p class="body-textb1"><b>Heinrichshofen</b> Edition <b>[16, 17]</b></p>
<p class="hangb1">Liebigstraße 15</p>
<p class="hangb1">26389 Wilhelmshaven, Germany</p>
<p class="hangb1">Tel: (49) 4421-9267-0</p>
<p class="hangb1">Fax: (49) 4421-9267-99<br/><a href="http://www.heinrichshofen.de" target="_blank">www.heinrichshofen.de</a></p>
<p class="body-textb1"><b>Helicon</b> Music (<i>see</i> Schott)</p>
<p class="body-textb1"><b>Helios</b> Music Edition (<i>see</i> Plymouth Music)</p>
<p class="body-textb1">G. <b>Henle</b> USA. Inc. <b>[6, 8, 10, 17]</b></p>
<p class="hangb1">Forstenrieder Allee 122</p>
<p class="hangb1">81476 Munchen, Germany</p>
<p class="hangb1">Tel: (49) 89-759-82-0</p>
<p class="hangb1">Fax: (49) 89-759-82-40<br/><a href="http://www.henleusa.com" target="_blank">www.henleusa.com</a></p>
<p class="body-textb1"><b>Henmar</b> Press (USA) <b>[14]</b></p>
<p class="body-textb1">Éditions <b>Henn</b></p>
<p class="hangb1">5-7 Rue de l'Ancien-Port<br/>1201 Geneva, Switzerland</p>
<p class="hangb1">Tel: (41) 22-738-91-10</p>
<p class="hangb1">Fax: (41) 22-738-91-16</p>
<p class="body-textb1">HBS <b>Hepomuk</b></p>
<p class="hangb1">Entfelderstrasse 39</p>
<p class="hangb1">5000 Aarau, Switzerland<br/><a href="http://www.hbs-nepomuk.ch" target="_blank">www.hbs-nepomuk.ch</a></p>
<p class="body-textb1"><b>Hermes Beard</b> Press</p>
<p class="hangb1">7121 Viewpoint Road<br/>Aptos, CA 95003</p>
<p class="body-textb1"><b>Heugel [13, 15, 17]</b> (<i>see</i> Leduc)</p>
<p class="hangb1">Paris, France</p>
<p class="body-textb1">Editions <b>Heuwekemeijer [13]</b></p>
<p class="hangb1"><a href="http://www.editionheuwekemeijer.nl" target="_blank">www.editionheuwekemeijer.nl</a></p>
<p class="body-textb1"><b>Hidden Oaks</b> Music Company</p>
<p class="hangb1">P.O. Box 47696<br/>San Antonio, TX 78284-9765</p>
<p class="hangb1">Tel: (210) 590-1689<br/><a href="http://www.efabregas.com" target="_blank">www.efabregas.com</a></p>
<p class="body-textb1"><b>Highgate</b> Press <b>[5]</b></p>
<p class="body-textb1"><b>Hildegard</b> Publishing Company <b>[6, 13, 15, 17]</b></p>
<p class="hangb1">P.O. Box 18860<br/>Mount Airy, PA 19010</p>
<p class="hangb1">Tel: (610) 667-8634</p>
<p class="hangb1">Fax: (215) 359-0654<br/><a href="http://www.hildegard.com" target="_blank">www.hildegard.com</a></p>
<p class="body-textb1"><b>Hinrichsen</b> Edition (England) <b>[14, 17]</b></p>
<p class="body-textb1"><b>Hinshaw</b> Music <b>[6, 17]</b></p>
<p class="hangb1">(Hinshaw no longer publishes piano literature)</p>
<p class="body-textb1">Friedrich <b>Hofmeister</b> (Germany) <b>[6, 17,</b> <i>see also:</i> William Elkin]</p>
<p class="body-textb1"><b>Hope</b> Publishing Co.</p>
<p class="hangb1">380 South Main Place<br/>Carol Stream, IL 60188<br/>Tel: (800) 323-1049 or (630) 665-3200</p>
<p class="hangb1">Fax: (630) 665-2552<br/><a href="http://www.hopepublishing.com" target="_blank">www.hopepublishing.com</a></p>
<p class="body-textb1"><b>Hudební Matice</b> (Czech Republic) <b>[18]</b> (no longer in business)</p>
<p class="body-textb1"><b>Hug [6, 11, 17]</b></p>
<p class="hangb1">Case Postale 6455</p>
<p class="hangb1">1002 Lausanne, Switzerland</p>
<p class="hangb1">Tel: (41) 21-310-48-10</p>
<p class="hangb1">Fax: (41) 21-310-48-19<br/><a href="http://www.musikhug.ch" target="_blank">www.musikhug.ch</a></p>
<p class="body-textb1"><b>Hyperion</b> Press</p>
<p class="hangb1">45 Riverside Avenue<br/>Westport, CT 06880<br/>*Division of Disney Book Publishing<br/>114 Fifth Avenue<br/>New York, NY 10011</p>
<p class="hangb1">Tel: (800) 343-9204 or (212) 633-4400</p>
<p class="hangb1">Fax: (212) 633-4811</p>
<p class="body-textb1"><b>Ichthys</b> Verlag GmbH <b>[18]</b></p>
<p class="body-textb1"><b>IMI</b> (<i>see</i> Israel Music Institute)</p>
<p class="body-textb1"><b>Imma</b> Publishing Company</p>
<p class="hangb1">1600 East Avenue, #1115<br/>Rochester, NY 14610<br/>Tel: (585) 413-1651<br/><a href="http://www.martaandriasova.webs.com" target="_blank">www.martaandriasova.webs.com</a></p>
<p class="body-textb1"><b>Impero</b>-Verlag <b>[13]</b></p>
<p class="body-textb1"><b>Imprimus</b> Music (<i>see</i> Sikesdi Press)</p>
<p class="body-textb1"><b>Indiana University</b></p>
<p class="hangb1">William and Gayle Cook Music Library</p>
<p class="hangb1">Simon Music Library &amp; Recital Center</p>
<p class="hangb1">200 South Jordan Avenue</p>
<p class="hangb1">Bloomington, IN 47405</p>
<p class="hangb1">Tel: (812) 855-2970</p>
<p class="hangb1">Fax: (812) 855-3843</p>
<p class="hangb1"><a href="http://www.music.indiana.edu/muslib" target="_blank">www.music.indiana.edu/muslib</a></p>
<p class="body-textb1"><b>Instituto de Extensión Musicale</b></p>
<p class="hangb1">Calle Compañia<br/>1274 Santiago, Chile</p>
<p class="body-textb1"><b>International Music Company [10, 17]</b></p>
<p class="hangb1">5 W. 37th Street<br/>New York, NY 10018</p>
<p class="hangb1">Tel: (212) 391-4200</p>
<p class="hangb1">Fax: (212) 391-4306<br/><a href="http://www.internationalmusicco.com" target="_blank">www.internationalmusicco.com</a></p>
<p class="body-textb1"><b>Internationale Gesellschaft für Neue Musik</b></p>
<p class="hangb1">(International Society for New Music)</p>
<p class="hangb1">Sektion Österreich</p>
<p class="hangb1">Ungargasse 11/12</p>
<p class="hangb1">1030 Vienna, Austria</p>
<p class="hangb1">Tel: (43) 1-23-63-803</p>
<p class="hangb1"><a href="http://www.ignm.at" target="_blank">www.ignm.at</a></p>
<p class="body-textb1"><b>Intitución Fernando el Católico</b></p>
<p class="hangb1">Plaza de España, 2</p>
<p class="hangb1">50071 Zaragoza, Spain</p>
<p class="hangb1">Tel: (34) 976 288 878/79</p>
<p class="hangb1">Fax: (34) 976 288 869</p>
<p class="hangb1"><a href="http://ifc.dpz.es" target="_blank">http://ifc.dpz.es</a></p>
<p class="body-textb1"><b>Intrepid Pixels</b> Publishing</p>
<p class="hangb1">820 West End Avenue, Box 9E<br/>New York, NY 10025<br/>Tel: (212) 866-3939</p>
<p class="hangb1">Fax: (212) 280-8187</p>
<p class="body-textb1"><b>Ione Press,</b> Inc. <b>[5]</b></p>
<p class="hangb1">138 Ipswich Street<br/>Boston, MA 02215</p>
<p class="hangb1">Tel: (617) 236-1935</p>
<p class="hangb1">Fax: (617) 236-0261</p>
<p class="body-textb1"><b>Israel Music Institute</b> (IMI) <b>[13, 15]</b></p>
<p class="hangb1">55 Menachem Begin Road<br/>67138 Tel Aviv, Israel</p>
<p class="hangb1">Tel: (972) 3-624-70-95</p>
<p class="hangb1">Fax: (972) 3-561-28-26<br/><a href="http://www.imi.org.il" target="_blank">www.imi.org.il</a></p>
<p class="body-textb1"><b>Israeli Music Publications [13, 15]<br/>Japan Federation of Composers</b></p>
<p class="hangb1">#101, Mimori-Building<br/>1-19-4 Hatsudai</p>
<p class="hangb1">Shibuya-Ku, Tokyo 151-0061 Japan</p>
<p class="hangb1">Tel: (81) 3-6276-1177</p>
<p class="hangb1">Fax: (81) 3-3376-3371<br/><a href="http://www.jfc.gr.jp" target="_blank">www.jfc.gr.jp</a></p>
<p class="body-textb1"><b>Japanese Society of Rights of Authors and Composers</b></p>
<p class="hangb1"><a href="http://www.jasrac.or.jp" target="_blank">www.jasrac.or.jp</a></p>
<p class="body-textb1"><b>Jaymar</b> Music</p>
<p class="hangb1">P.O. Box 2191, Stn. B<br/>London, Ontario N6A 4E3, Canada</p>
<p class="hangb1">Tel: (519) 672-7369</p>
<p class="hangb1">Fax: (519) 672-0016</p>
<p class="body-textb1"><b>Jerona</b> Music Corp. <b>[6]</b></p>
<p class="hangb1">224 King Street<br/>Englewood, NJ 07631</p>
<p class="hangb1">Tel: (201) 568-8448</p>
<p class="hangb1">Fax: (201) 569-7023</p>
<p class="body-textb1">Jean <b>Jobert</b>/Editions Jobert et Cie <b>[6, 13, 15, 17]</b></p>
<p class="hangb1">27 Boulevard Beaumarchais<br/>75004 Paris, France</p>
<p class="hangb1">Tel: (33) 1-56-68-86-60</p>
<p class="hangb1">Fax: (33) 1-56-68-90-66<br/><a href="http://www.jobert.fr" target="_blank">www.jobert.fr</a></p>
<p class="body-textb1"><b>Joclem</b> Music Publishing <b>[2]</b></p>
<p class="body-textb1"><b>Johnson</b> Reprint Corp.</p>
<p class="hangb1">111 Fifth Avenue<br/>New York, NY 10003</p>
<p class="body-textb1"><b>Joshua</b> Corp. (<i>see</i> Boston Music Company)</p>
<p class="body-textb1"><b>Editions Joubert [18]</b></p>
<p class="body-textb1">P. <b>Jürgenson [14]</b></p>
<p class="hangb1">2/46 Bolshaya Sadovaya St.<br/>Moscow 123001, Russia</p>
<p class="hangb1">Tel: (7) 495-254-8180</p>
<p class="hangb1">Fax: (7) 495-609-0793<br/><a href="http://www.jurgenson.pro" target="_blank">www.jurgenson.pro</a></p>
<p class="body-textb1">C. F. <b>Kahnt [14]</b></p>
<p class="hangb1">Frankfurt, Germany</p>
<p class="body-textb1"><b>Kallisti</b> Music Press</p>
<p class="hangb1">810 S. Saint Bernard Street<br/>Philadelphia, PA 19143-3309</p>
<p class="hangb1">Tel: (215) 724-6511 or (800) 260-2881<br/><a href="http://www.kallistimusic.com" target="_blank">www.kallistimusic.com</a></p>
<p class="body-textb1">Edwin F. <b>Kalmus [6, 8, 17]</b></p>
<p class="hangb1">P.O. Box 5011<br/>Boca Raton, FL 33431</p>
<p class="hangb1">Tel: (800) 434-6340</p>
<p class="hangb1">Fax: (561) 241-6347<br/><a href="http://www.efkalmus.com" target="_blank">www.efkalmus.com</a></p>
<p class="body-textb1"><b>Edition Kemel</b></p>
<p class="hangb1">Niedernhausen, Germany</p>
<p class="body-textb1"><b>Kenyon</b> Publications <b>[10, 13, 17]</b></p>
<p class="body-textb1">E. C. <b>Kerby [10, 13, 17]</b></p>
<p class="hangb1">Toronto, Canada</p>
<p class="body-textb1"><b>Keturi</b> Musikverlag</p>
<p class="hangb1">Postfach 1120<br/>83251 Rimsting, Germany</p>
<p class="hangb1">Tel: (49) 8051-1634</p>
<p class="hangb1">Fax: (49) 8051-63042<br/><a href="http://www.arends-musikverlag.de" target="_blank">www.arends-musikverlag.de</a></p>
<p class="body-textb1">The <b>Keys Press</b> (available through Theodore Front)</p>
<p class="hangb1">66 Clotilde Street<br/>Mount Lawley<br/>Western Australia 6050, Australia</p>
<p class="hangb1">Tel: (61-8) 9271-6547</p>
<p class="hangb1">Fax: (61-8) 9271-6581<br/><a href="http://www.keyspress.com.au" target="_blank">www.keyspress.com.au</a></p>
<p class="body-textb1">Robert <b>King</b></p>
<p class="hangb1">140 Main Street<br/>North Easton, MA 02356<br/>Fax: (508) 238-2571<br/><a href="http://www.rkingmusic.com" target="_blank">www.rkingmusic.com</a></p>
<p class="body-textb1"><b>Kistner &amp; Siegel [18]</b></p>
<p class="body-textb1"><b>Kultura [18]</b></p>
<p class="body-textb1"><b>Kunzelmann</b> (Switzerland) <b>[6, 14, 17]</b></p>
<p class="body-textb1"><b>La Jolla</b> Publishing <b>[9]</b></p>
<p class="body-textb1">Éditions Musicales <b>Labatiaz</b></p>
<p class="hangb1">Case postale 112</p>
<p class="hangb1">1890 St-Maurice, Switzerland<br/>Tel/Fax: (41) 24-485-24-80<br/><a href="http://www.editions-labatiaz.com" target="_blank">www.editions-labatiaz.com</a></p>
<p class="body-textb1"><b>Laurentius</b> Musikverlag</p>
<p class="hangb1">Dr. Wolfram Hader<br/>Stegerwaldstraße 21<br/>65929 Frankfurt a.M., Germany</p>
<p class="hangb1">Tel: (49) 69-26-49-47-38</p>
<p class="hangb1">Fax: (49) 69-93-62-34-49<br/><a href="http://www.laurentius-musikverlag.de" target="_blank">www.laurentius-musikverlag.de</a></p>
<p class="body-textb1"><b>Lawson Gould</b> Music Publishers <b>[17]</b></p>
<p class="body-textb1"><b>Lea</b> Pocket Scores <b>[2]</b></p>
<p class="body-textb1">Alphonse <b>Leduc [6, 13, 15]</b> (also available in U.S. through Robert King)</p>
<p class="hangb1">175, rue Saint-Honoré<br/>75040 Paris Cedex 01, France</p>
<p class="hangb1">Tel: (33) 1-42-96-89-11</p>
<p class="hangb1">Fax: (33) 1-42-86-02-83<br/><a href="http://www.alphonseleduc.com" target="_blank">www.alphonseleduc.com</a></p>
<p class="body-textb1"><b>Lee Roberts [13, 17]</b></p>
<p class="hangb1">P.O. Box 341<br/>Chatham, NY 12037</p>
<p class="hangb1">Tel: (518) 533-4921<br/><a href="http://www.leerobertsmusic.com" target="_blank">www.leerobertsmusic.com</a></p>
<p class="body-textb1"><b>Leeds Music Corp.</b> (<i>see</i> Universal Music Publishing Group)</p>
<p class="body-textb1"><b>Leeds Music Ltd.</b> (Canada) (<i>see</i> Universal Music Publishing Group)</p>
<p class="body-textb1">Robert Owen <b>Lehman</b> Foundation</p>
<p class="hangb1">c/o The Morgan Library &amp; Museum<br/>225 Madison Avenue<br/>New York, NY 10016</p>
<p class="hangb1">Tel: (212) 685-0008<br/><a href="http://www.themorgan.org/research/collectionsMusic.asp" target="_blank">http://www.themorgan.org/research/collectionsMusic.asp</a></p>
<p class="body-textb1">Henry <b>Lemoine [6, 13, 15, 17]</b></p>
<p class="hangb1">27 Boulevard Beaumarchais<br/>75004 Paris, France</p>
<p class="hangb1">Tel: (33) 1-56-68-86-65</p>
<p class="hangb1">Fax: (33) 1-56-68-90-66<br/><a href="http://www.henry-lemoine.com" target="_blank">www.henry-lemoine.com</a></p>
<p class="body-textb1">Alfred <b>Lengnick</b> [<i>see also:</i> William Elkin] <b>[13]</b></p>
<p class="body-textb1">Wayne <b>Leopold</b> Editions</p>
<p class="hangb1">8510 Triad Drive<br/>Colfax, NC 27235</p>
<p class="hangb1">Tel: (800) 765-3196<br/><a href="http://www.wayneleupold.com" target="_blank">www.wayneleupold.com</a></p>
<p class="body-textb1"><b>Lerolle [18]</b></p>
<p class="hangb1">Paris, France</p>
<p class="body-textb1">Editorial <b>Letras Cubanas</b></p>
<p class="hangb1">Calle G, No. 505<br/>El Vedado<br/>Habana, Cuba<br/><a href="http://www.ecured.cu/index.php/Editorial_Letras_Cubanas" target="_blank">www.ecured.cu/index.php/Editorial_Letras_Cubanas</a></p>
<p class="body-textb1">F. E. C. <b>Leuckart [6, 10]</b></p>
<p class="hangb1">Rheingoldstr. 4<br/>80639 Munich, Germany</p>
<p class="hangb1">Tel: (49) 8917-3928</p>
<p class="hangb1">Fax: (49) 8917-6054</p>
<p class="body-textb1"><b>Lewis</b> Music Publishing Co. <b>[16]</b></p>
<p class="body-textb1"><b>Library of Congress</b></p>
<p class="hangb1">Music Division<br/>James Madison Memorial Bldg.<br/>101 Independence Avenue, SE<br/>Washington, DC 20540-4710</p>
<p class="hangb1">Tel: (202) 707-5507<br/><a href="http://www.loc.gov/rr/perform/" target="_blank">http://www.loc.gov/rr/perform/</a></p>
<p class="body-textb1">Robert <b>Lienau</b> Musikverlag <b>[6, 14, 17]</b></p>
<p class="hangb1">Tel: (49) 69-978286-6</p>
<p class="hangb1">Fax: (49) 69-978286-79<br/>Frankfurt, Germany<br/><a href="http://www.lienau-frankfurt.de" target="_blank">www.lienau-frankfurt.de</a></p>
<p class="body-textb1"><b>Lingua Press</b></p>
<p class="hangb1">P.O. Box 1192<br/>La Jolla, CA 92038</p>
<p class="body-textb1">Collection <b>Litolff [14]</b></p>
<p class="body-textb1"><b>Longman [2]</b></p>
<p class="hangb1">1560 Broadway<br/>New York, NY 10036</p>
<p class="body-textb1">Harald <b>Lyche</b> &amp; Co.</p>
<p class="hangb1">Postboks 2171 Str<img alt="images" src="images/c1.jpg" style="height: auto; width: auto; margin:0px 0px 0px 0px; padding:0px 0px 0px 0px; border:0px;"/>ms<img alt="images" src="images/c1.jpg" style="height: auto; width: auto; margin:0px 0px 0px 0px; padding:0px 0px 0px 0px; border:0px;"/><br/>3001 Drammen, Norway<br/>Tel: (47) 32-24-50-00</p>
<p class="body-textb1"><b>Lyrebird</b> Press (Editions de l'Oiseau-Lyre)</p>
<p class="hangb1">Faculty of Music<br/>University of Melbourne<br/>VIC 3010, Australia</p>
<p class="hangb1">Fax: (61) 3-8344-5346<br/><a href="http://www.lyrebirdpress.com" target="_blank">www.lyrebirdpress.com</a></p>
<p class="body-textb1">Vieira <b>Machado</b> Editores</p>
<p class="hangb1">Rio de Janeiro, Brazil</p>
<p class="body-textb1"><b>Maecenas</b> Music <b>[17]</b></p>
<p class="hangb1">5 Bushey Close<br/>Old Barn Lane<br/>Kenley, Surrey CR8 5AU<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 20-8660-3914</p>
<p class="hangb1">Fax: (44) 20-8668-5273<br/><a href="http://www.maecenasmusic.co.uk" target="_blank">www.maecenasmusic.co.uk</a></p>
<p class="body-textb1"><b>Maestro</b> (<i>see</i> Hansen House)</p>
<p class="body-textb1">Pierre <b>Mardaga</b> Editeur, S.A.</p>
<p class="hangb1">Avenue Pasteur 6—Bât. H<br/>1300 Wavre, Belgium<br/>Tel: (32) 10-686452<br/><a href="http://www.mardaga.be" target="_blank">www.mardaga.be</a></p>
<p class="body-textb1"><b>Margun/Gunmar Music [10, 17]</b></p>
<p class="hangb1">167 Dudley Road<br/>Newton Center, MA 02159<br/>Tel: (617) 332-6398</p>
<p class="hangb1">Fax: (617) 969-1079</p>
<p class="body-textb1">Edward B. <b>Marks [10, 13, 15, 17]</b></p>
<p class="hangb1">126 E. 38th Street<br/>New York, NY 10016<br/>Tel: (212) 779-7977</p>
<p class="hangb1">Fax: (212) 779-7920<br/><a href="http://www.ebmarks.com" target="_blank">www.ebmarks.com</a></p>
<p class="body-textb1"><b>Masters</b> Music Publications <b>[6, 8, 17]</b></p>
<p class="hangb1">6403 W. Rogers Circle</p>
<p class="hangb1">Boca Raton, FL 33487</p>
<p class="hangb1">Tel: (561) 241-6169 or (800) 434-6340</p>
<p class="hangb1">Fax: (561) 241-6347</p>
<p class="hangb1"><a href="http://www.masters-music.com" target="_blank">www.masters-music.com</a></p>
<p class="body-textb1"><b>Materiali Sonori</b></p>
<p class="hangb1">Via Tre Novembre 2</p>
<p class="hangb1">52027 San Giovanni Valdarno, Italy</p>
<p class="hangb1">Tel: (39) 559120363</p>
<p class="hangb1">Fax: (39) 559120370<br/><a href="http://www.matson.it" target="_blank">www.matson.it</a></p>
<p class="body-textb1">Kevin <b>Mayhew [3, 6, 17]</b></p>
<p class="hangb1">Buxhall<br/>Stowmarket<br/>Suffolk IP14 3BW<br/>United Kingdom<br/>Tel: (44) 845-388-1634</p>
<p class="hangb1">Fax: (44) 1449-737834<br/><a href="http://www.kevinmayhew.com" target="_blank">www.kevinmayhew.com</a></p>
<p class="body-textb1"><b>MCA</b> Music Publishing (<i>see</i> Universal Music Publishing Group) <b>[13, 17]</b></p>
<p class="body-textb1"><b>McAfee</b> Music Corp. <b>[1]</b></p>
<p class="body-textb1"><b>McGinnis &amp; Marx [6, 17]</b></p>
<p class="hangb1">236 West 26th Street, #11S<br/>New York, NY 10001-6736<br/>Tel: (212) 675-1630</p>
<p class="hangb1">Fax: (212) 675-1630</p>
<p class="body-textb1">Edition Tilo <b>Medek</b></p>
<p class="hangb1">Rheinhöhe, Westerwaldweg 22</p>
<p class="hangb1">53424 Remagen-Oberwinter, Germany</p>
<p class="hangb1">Tel: (49) 2228-8175</p>
<p class="hangb1">Fax: (49) 2228-8176<br/><a href="http://www.medek.net" target="_blank">www.medek.net</a></p>
<p class="body-textb1"><b>Melos</b> Ediciones Musicales <b>[6]</b></p>
<p class="hangb1">Tte. Gral. Juan D. Perón 1560<br/>C1037ACD Buenos Aires, Argentina</p>
<p class="hangb1">Tel: (54) 11-4371-9841<br/><a href="http://www.melos.com.ar" target="_blank">www.melos.com.ar</a></p>
<p class="body-textb1"><b>Mercury</b> Music Corp. <b>[13, 15]</b> (a subsidiary of TP)</p>
<p class="hangb1"><a href="http://www.presser.com" target="_blank">www.presser.com</a></p>
<p class="body-textb1"><b>Merion</b> Music, Inc. <b>[15, 17]</b> (a subsidiary of TP)</p>
<p class="hangb1"><a href="http://www.presser.com" target="_blank">www.presser.com</a></p>
<p class="body-textb1"><b>Merseburger [6]</b></p>
<p class="hangb1">Naumburger Str. 40</p>
<p class="hangb1">43127 Kassel, Germany</p>
<p class="hangb1">Tel: (49) 561-789809-11</p>
<p class="hangb1">Fax: (49) 561-789809-16<br/><a href="http://www.merseburger.de" target="_blank">www.merseburger.de</a></p>
<p class="body-textb1"><b>Metropolis</b> Editions <b>[18]</b></p>
<p class="body-textb1">Ediciones <b>Mexicanas</b> de Música <b>[15]</b></p>
<p class="body-textb1"><b>Mills</b> Music <b>[18]</b></p>
<p class="body-textb1"><b>Minkoff</b> Musique et Musicologie / Éditions Minkoff</p>
<p class="hangb1">8, rue Eynar<br/>1211 Geneva 12, Switzerland</p>
<p class="hangb1">Tel: (41-22) 310-46-60</p>
<p class="hangb1">Fax: (41-22) 310-28-57</p>
<p class="body-textb1"><b>Mira</b> Music Associates</p>
<p class="hangb1">199 Mountain Road<br/>Wilton, CT 06897-1526<br/>Tel: (302) 762-5186</p>
<p class="body-textb1"><b>Mitteldeutscher</b> Verlag <b>[18]</b></p>
<p class="body-textb1"><b>MJQ</b> Music <b>[10]</b></p>
<p class="body-textb1"><b>Mobart</b> Music Publications (<i>see</i> Boelke-Bomart)</p>
<p class="body-textb1">Uitgeverij <b>Moebiprint</b></p>
<p class="hangb1">Hercules Segherslaan 28<br/>1701 XB Heerhugowaard<br/>The Netherlands</p>
<p class="hangb1">Tel: (31) 07-2571-5172</p>
<p class="body-textb1">Hermann <b>Moeck</b> Verlag <b>[6, 13, 16, 17]</b></p>
<p class="hangb1">Postfach 3131<br/>29231 Celle, Germany</p>
<p class="hangb1">Tel: (49) 5141-8853-0</p>
<p class="hangb1">Fax: (49) 5141-8853-42<br/><a href="http://www.moeck.com" target="_blank">www.moeck.com</a></p>
<p class="body-textb1">Editio <b>Moravia</b></p>
<p class="hangb1">Hvozdec 55<br/>664 71 Veverská Bítýška<br/>Tel/Fax: (420) 549-420-675<br/><a href="http://www.editiomoravia.cz" target="_blank">www.editiomoravia.cz</a></p>
<p class="body-textb1"><b>Moravian</b> Music Foundation Press</p>
<p class="hangb1">c/o Assoc. University Presses<br/>440 Forsgate Drive<br/>Cranbury, NJ 08512<br/>Tel: (609) 655-4770</p>
<p class="body-textb1">Edwin H. <b>Morris [10]</b></p>
<p class="hangb1">39 West 54th Street<br/>New York, NY 10019</p>
<p class="body-textb1">Karl Heinrich <b>Möseler</b> Verlag <b>[6]</b></p>
<p class="hangb1">Hoffmann-v.-F.-Str. 8</p>
<p class="hangb1">38304 Wolfenbüttel, Germany</p>
<p class="hangb1">Tel: (49) 5331-95970</p>
<p class="hangb1">Fax: (49) 5331-959720<br/><a href="http://www.moeseler-verlag.de" target="_blank">www.moeseler-verlag.de</a></p>
<p class="body-textb1"><b>Mowbray</b> Music Publishers <b>[13, 15]</b></p>
<p class="body-textb1">Willy <b>Müller</b> (<i>see</i> Bärenreiter)</p>
<p class="body-textb1">Musikverlag <b>Müller &amp; Schade</b></p>
<p class="hangb1">Moserstrasse 16</p>
<p class="hangb1">3014 Bern, Switzerland</p>
<p class="hangb1">Tel: (41) 31-320-26-26</p>
<p class="hangb1">Fax: (41) 31-320-26-27<br/><a href="http://www.mueller-schade.com" target="_blank">www.mueller-schade.com</a></p>
<p class="body-textb1">Ediciones Musicales <b>Mundimúsica</b></p>
<p class="hangb1">Espejo, 4<br/>28013 Madrid, Spain</p>
<p class="hangb1">Tel: (34) 91-548-17-94</p>
<p class="hangb1">Fax: (34) 91-548-17-53<br/><a href="http://www.mundimusica.es" target="_blank">www.mundimusica.es</a></p>
<p class="body-textb1"><b>Murdoch &amp; Murdoch</b> (London) <b>[18]</b></p>
<p class="body-textb1"><b>Music</b> Graphics Press</p>
<p class="hangb1">3409 Dickens Street<br/>San Diego, CA 92106<br/>Tel: (619) 523-1962</p>
<p class="body-textb1"><b>Music Press [7]</b></p>
<p class="body-textb1"><b>Music Sales Limited [13, 17]</b></p>
<p class="hangb1">Newmarket Road<br/>Bury St. Edmund<br/>Suffolk IP33 3YB, United Kingdom</p>
<p class="body-textb1"><b>Music Treasure</b> Publications</p>
<p class="hangb1">620 Fort Washington Avenue, #1F<br/>New York, NY 10040-3930</p>
<p class="body-textb1"><b>Musica Islandica</b></p>
<p class="hangb1">Iceland Music Information Centre<br/>Sidumuli 34</p>
<p class="hangb1">108 Reykjavik, Iceland</p>
<p class="hangb1">Tel: (354) 568-3122</p>
<p class="hangb1">Fax: (354) 568-3124<br/><a href="http://www.mic.is" target="_blank">www.mic.is</a></p>
<p class="body-textb1">Editorial <b>Musica Moderna [18]</b></p>
<p class="body-textb1">Editora <b>Música Nova</b> do Brasil</p>
<p class="hangb1">Rua Pres. Carlos de Campos 115<br/>bl.02/902<br/>22231-080 Rio de Janeiro, Brazil</p>
<p class="hangb1">Tel: (55) 21-2553-6222</p>
<p class="hangb1">Fax: (55) 21-2553-9963<br/><a href="http://www.sites.uol.com.br/marlosnobre" target="_blank">www.sites.uol.com.br/marlosnobre</a></p>
<p class="body-textb1"><b>Musica Obscura</b> Editions <b>[6]</b></p>
<p class="hangb1">17 Joey Road</p>
<p class="hangb1">Merrimack, NH 03054-4549</p>
<p class="hangb1">Tel: (603) 881-7210</p>
<p class="hangb1">Fax: (603) 595-8382</p>
<p class="body-textb1"><b>Musica Rara [6]</b></p>
<p class="hangb1">215 Bailey Avenue<br/>Rock Hill, SC 29732-1003</p>
<p class="hangb1">Tel: (803) 366-4446</p>
<p class="hangb1">Fax: (803) 212-0016<br/><a href="http://www.musicarara.com" target="_blank">www.musicarara.com</a></p>
<p class="body-textb1">Editora <b>Musical Brasileira</b></p>
<p class="hangb1">Rio de Janeiro, Brazil</p>
<p class="body-textb1"><b>Musical Scope</b> Publishers <b>[18]</b></p>
<p class="body-textb1"><b>Musikk-Huset</b> Forlag</p>
<p class="hangb1">Postbox 1499 Vika<br/>0116 Oslo, Norway<br/>Tel: (47) 22-82-59-00</p>
<p class="hangb1">Fax: (47) 22-82-59-01<br/><a href="http://www.musikk-huset.no" target="_blank">www.musikk-huset.no</a></p>
<p class="body-textb1"><b>Musikwissenschaftlichen [14]</b></p>
<p class="hangb1">Dorotheergasse 10<br/>1010 Vienna, Austria</p>
<p class="hangb1">Tel: (43) 1-515-03-43</p>
<p class="hangb1">Fax: (43) 1-515-03-51<br/><a href="http://www.mwv.at" target="_blank">www.mwv.at</a></p>
<p class="body-textb1"><b>Muzblka</b></p>
<p class="hangb1">Moscow, Russia</p>
<p class="body-textb1">Editura <b>Muzicală</b></p>
<p class="hangb1">Calea Victoriei nr. 141, sector 1</p>
<p class="hangb1">71102 Bucharest, Romania<br/>Tel/Fax: (40) 21-312-98-67<br/><a href="http://www.edituramuzicala.ro" target="_blank">www.edituramuzicala.ro</a></p>
<p class="body-textb1"><b>Nagel's</b> Musik-Archive (<i>see</i> Bärenreiter)</p>
<p class="body-textb1">Arthur <b>Napoleão [18]</b></p>
<p class="hangb1">Rio de Janeiro, Brazil</p>
<p class="body-textb1">Musikedition <b>Nepomuk</b> (<i>see</i> HBS Nepomuk)</p>
<p class="body-textb1"><b>New Music Edition [7, 10]</b></p>
<p class="body-textb1"><b>New Music USA</b></p>
<p class="hangb1">90 John Street, Suite 312<br/>New York City, NY 10038</p>
<p class="hangb1">Tel: (212) 645-6949</p>
<p class="hangb1">Fax: (646) 490-0998<br/><a href="http://library.newmusicusa.org" target="_blank">library.newmusicusa.org</a></p>
<p class="body-textb1"><b>New Music West</b></p>
<p class="hangb1">1437 Crest Drive<br/>Altadena, CA 91001<br/>Tel: (626) 794-1684</p>
<p class="body-textb1"><b>New World Music</b> Corp. <b>[1]</b></p>
<p class="body-textb1">Pierre <b>Noël</b> (<i>see</i> Billaudot)</p>
<p class="body-textb1">Otto Heinrich <b>Noetzel</b> Verlag <b>[14]</b></p>
<p class="hangb1">Liebigstraße 15</p>
<p class="hangb1">26389 Wilhelmshaven, Germany</p>
<p class="hangb1">Tel: (49) 4421-9267-0</p>
<p class="hangb1">Fax: (49) 4421-9267-99<br/><a href="http://www.heinrichshofen.de" target="_blank">www.heinrichshofen.de</a></p>
<p class="body-textb1"><b>Nordiska</b> Musikförlaget <b>[6, 16]</b></p>
<p class="hangb1">c/o Gehrmans Musikförlag<br/>Box 42026</p>
<p class="hangb1">126 12 Stockholm, Sweden</p>
<p class="hangb1">Tel: (46) 8-610-06-00</p>
<p class="hangb1">Fax: (46) 8-610-06-27</p>
<p class="body-textb1"><b>Norruth</b> Music <b>[12]</b></p>
<p class="hangb1">St. Louis, MO 63103</p>
<p class="body-textb1"><b>Norsk</b> Musikforläg <b>[6, 17]</b></p>
<p class="hangb1">Postboks 1499 Vika<br/>0116 Oslo, Norway</p>
<p class="hangb1">Tel: (47) 23-00-21-10</p>
<p class="hangb1">Fax: (47) 23-00-20-11<br/><a href="http://www.norskmusikkforlag.no" target="_blank">www.norskmusikkforlag.no</a></p>
<p class="body-textb1"><b>Norton</b> Critical Scores</p>
<p class="hangb1">W. W. Norton<br/>500 Fifth Avenue<br/>New York, NY 10110<br/>Tel: (800) 233-4830 or (212) 354-5500</p>
<p class="hangb1">Fax: (212) 869-0856<br/><a href="http://www.wwnorton.com" target="_blank">www.wwnorton.com</a></p>
<p class="body-textb1"><b>Nottingham</b> Square Publications</p>
<p class="hangb1">c/o Music Publishing Services<br/>236 W. 26th Street, Suite 11-S<br/>New York, NY 10001<br/>Tel: (212) 243-5233</p>
<p class="hangb1">Fax: (212) 675-1630</p>
<p class="body-textb1">Editora <b>Novas Metas</b></p>
<p class="hangb1">São Paulo, Brazil</p>
<p class="body-textb1"><b>Novello [6, 10, 13, 16, 17]</b> (now part of Music Sales Group)</p>
<p class="hangb1">14-15 Berners Street<br/>London W1T 3LJ<br/>United Kingdom<br/>Tel: (44) 20-7612-7400</p>
<p class="hangb1">Fax: (44) 20-7612-7545<br/><a href="http://www.chesternovello.com" target="_blank">www.chesternovello.com</a></p>
<p class="body-textb1"><b>Oertel</b> Verlag <b>[17]</b></p>
<p class="body-textb1"><b>Oesterreichischer Bundesverlag</b></p>
<p class="hangb1">Frankgasse 4</p>
<p class="hangb1">1090 Vienna, Austria</p>
<p class="hangb1">Tel: (43) 1-401-36-36</p>
<p class="hangb1">Fax: (43) 1-401-36-60<br/><a href="http://www.oebv.at" target="_blank">www.oebv.at</a></p>
<p class="body-textb1">Éditions de l<b>'Oiseau-Lyre [6, 11, 17]</b> (now taken over by Lyrebird Press)</p>
<p class="body-textb1"><b>OMI</b> (Old Manuscripts and Incunabula)</p>
<p class="hangb1">P.O. Box 6019 FDR Station<br/>New York, NY 10150</p>
<p class="hangb1">Tel: (212) 758-1946</p>
<p class="hangb1">Fax: (212) 593-6186<br/><a href="http://www.omifacsimiles.com" target="_blank">www.omifacsimiles.com</a></p>
<p class="body-textb1"><b>Ongaku-No-Tomo-Sha [6, 13, 15, 17]</b></p>
<p class="hangb1"><a href="http://www.ongakunotomo.co.jp" target="_blank">www.ongakunotomo.co.jp</a></p>
<p class="body-textb1">Editions <b>Orphée [13, 15, 17]</b></p>
<p class="hangb1">1240 Clubview Blvd. N.<br/>Columbus, OH 43235-1226</p>
<p class="hangb1">Tel: (614) 846-9517</p>
<p class="hangb1">Fax: (614) 846-9794<br/><a href="http://www.editionsorphee.com" target="_blank">www.editionsorphee.com</a></p>
<p class="body-textb1">Les Éditions <b>Ouvrières</b> (<i>see</i> Alphonse Leduc)</p>
<p class="body-textb1"><b>Oxford</b> University Press <b>[17]</b></p>
<p class="hangb1">198 Madison Avenue<br/>New York, NY 10016</p>
<p class="hangb1">Tel: (212) 726-6000<br/><i>Customer Service</i> (Orders):<br/>2001 Evans Road<br/>Cary, NC 27513</p>
<p class="hangb1">Tel: (800) 411-5445</p>
<p class="hangb1">Fax: (919) 677-1303<br/><a href="http://www.oup.com/us" target="_blank">www.oup.com/us</a></p>
<p class="body-textb1"><b>Pan American Union</b> (<i>see</i> Peermusic)</p>
<p class="body-textb1"><b>Panton</b> International (<i>see</i> European American Music Distributors)</p>
<p class="body-textb1"><b>Papagena</b> Press <b>[6, 15, 17]</b></p>
<p class="hangb1">Box 20484, Park West Station<br/>New York, NY 10025</p>
<p class="hangb1">Fax: (212) 316-2235<br/><a href="http://www.papagenapress.com" target="_blank">www.papagenapress.com</a></p>
<p class="body-textb1"><b>Papagrigoriou-Nakas</b> Music Publications</p>
<p class="hangb1">(Ch. Nakas—C. Papagrigoriou Co.)<br/>39 Panepistimiou Street<br/>105 64 Athens, Greece</p>
<p class="hangb1">Tel: (30) 210-32-21-786</p>
<p class="hangb1">Fax: (30) 210-32-22-742<br/><a href="http://www.panasmusic.com" target="_blank">www.panasmusic.com</a></p>
<p class="body-textb1"><b>Paragon</b> Music Publishers</p>
<p class="hangb1">c/o Brentwood-Benson Music<br/>Publishing<br/>5409 Maryland Way, Suite 200<br/>Brentwood, TN 37027</p>
<p class="hangb1">Tel: (615) 371-1320</p>
<p class="hangb1">Fax: (615) 371-1351<br/><a href="http://www.musicservices.org" target="_blank">www.musicservices.org</a></p>
<p class="body-textb1"><b>Parnaso</b></p>
<p class="hangb1">Rua N.S. Fatima, 231<br/>Porto, Portugal</p>
<p class="body-textb1">W. <b>Paxton [6]</b> (<i>see</i> Music Sales Ltd)</p>
<p class="hangb1">London, United Kingdom</p>
<p class="body-textb1"><b>Peer International</b> has become part of Peermusic Classical (810 Seventh Avenue, New York, NY 10019) <b>[6, 10, 13, 17]</b></p>
<p class="hangb1">250 W. 57th St., Suite 820</p>
<p class="hangb1">New York, NY 10107</p>
<p class="hangb1">Tel: (212) 265-3910</p>
<p class="hangb1">Fax: (212) 489-2465<br/><a href="http://www.peermusicclassical.com" target="_blank">www.peermusicclassical.com</a></p>
<p class="body-textb1"><b>Pennsylvania State</b> Music Series Publication of this series was discontinued in the 1970s; no longer available from the publisher.</p>
<p class="body-textb1">J. W. <b>Pepper &amp; Son</b></p>
<p class="hangb1">2480 Industrial Blvd.<br/>Paoli, PA 19301<br/>Tel: (800) 345-6296 or (610) 648-0500</p>
<p class="hangb1">Fax: (610) 993-0563<br/><a href="http://www.jwpepper.com" target="_blank">www.jwpepper.com</a></p>
<p class="body-textb1"><b>Permanent Press,</b> Music of Quality</p>
<p class="hangb1">7508 42nd Avenue, NE<br/>Seattle, WA 98115<br/>Tel: (206) 525-6596</p>
<p class="body-textb1"><b>Philharmusica Edition [8]</b></p>
<p class="hangb1"><a href="http://www.philharmusica.com" target="_blank">www.philharmusica.com</a></p>
<p class="body-textb1">Éditions <b>Philippo</b></p>
<p class="hangb1">c/o Éditions Combres<br/>27 Boulevard Beaumarchais<br/>75004 Paris, France<br/>Tel: (33) 1-56-68-86-64</p>
<p class="hangb1">Fax: (33) 1-56-68-90-66<br/><a href="http://www.editions-combre.com" target="_blank">www.editions-combre.com</a></p>
<p class="body-textb1"><b>Prhythm [1, 17]</b></p>
<p class="body-textb1"><b>Pioneer</b> Editions (<i>see</i> American Composers Alliance)</p>
<p class="body-textb1"><b>Piwarski</b> Verlag <b>[18]</b></p>
<p class="hangb1">Cracow, Poland</p>
<p class="body-textb1"><b>Plymouth</b> Music <b>[6]</b></p>
<p class="hangb1">170 NE 33rd Street<br/>Fort Lauderdale, FL 33334</p>
<p class="hangb1">Tel: (305) 563-1844</p>
<p class="hangb1">Fax: (305) 563-9006</p>
<p class="body-textb1"><b>Polish Music Publications/</b></p>
<p class="body-textb1"><b>Polskie Wydawnictwo Muzyczne</b> [PWM] <b>[6, 13, 15, 17]</b></p>
<p class="hangb1">al. Krasinskiego 11a<br/>31-111 Krakow, Poland<br/>Tel/Fax: (48-12) 422-71-71<br/><a href="http://www.pwm.com.pl" target="_blank">www.pwm.com.pl</a></p>
<p class="body-textb1"><b>Poon Hill</b> Press</p>
<p class="hangb1"><a href="http://www.poonhill.com" target="_blank">www.poonhill.com</a></p>
<p class="body-textb1"><b>Price Milburn [18]</b></p>
<p class="hangb1">Wellington, New Zealand</p>
<p class="body-textb1"><b>Printed Editions</b></p>
<p class="hangb1">P.O. Box 27<br/>Barrytown, NY 12507</p>
<p class="body-textb1"><b>Pro Organo [6]</b></p>
<p class="hangb1">Brühlstraße 42</p>
<p class="hangb1">88299 Leutkirch, Germany</p>
<p class="hangb1">Tel: (49) 7561-3398</p>
<p class="hangb1">Fax: (49) 7561-72188<br/><a href="http://www.pro-organo.com" target="_blank">www.pro-organo.com</a></p>
<p class="body-textb1"><b>Promethean</b> Editions <b>[17]</b></p>
<p class="hangb1">P.O. Box 10143<br/>Wellington, New Zealand</p>
<p class="hangb1">Tel: (64) 4-473-5033</p>
<p class="hangb1">Fax: (64) 4-473-5066<br/><a href="http://www.promethean-editions.co.nz" target="_blank">www.promethean-editions.co.nz</a></p>
<p class="body-textb1"><b>PRO/Scribes</b> Press</p>
<p class="hangb1">734 Wolcott Drive<br/>Philadelphia, PA 19118</p>
<p class="body-textb1"><b>Providence</b> Music Press</p>
<p class="hangb1">P.O. Box 2362<br/>East Side Station<br/>Providence, RI 02906</p>
<p class="body-textb1">Keith <b>Prowse</b> Music Publishing</p>
<p class="hangb1">London, United Kingdom</p>
<p class="body-textb1"><b>Publicacions de l'Abadia de Montserrat</b></p>
<p class="hangb1">Carrer d'Ausiàs Marc, 92-98<br/>0813 Barcelona, Spain</p>
<p class="hangb1">Tel: (34) 93-24-50-303</p>
<p class="hangb1">Fax: (34) 93-24-73-594<br/><a href="http://www.pamsa.cat/pamsa/inici" target="_blank">www.pamsa.cat/pamsa/inici</a>.</p>
<p class="body-textb1"><b>Queen's Temple Publications [6]</b></p>
<p class="hangb1">15 Mallard Drive<br/>Buckingham</p>
<p class="hangb1">Buckinghamshire MK18 1GJ United Kingdom</p>
<p class="hangb1">Tel/Fax: (44) 1280-813144<br/><a href="http://www.qtpublications.co.uk" target="_blank">www.qtpublications.co.uk</a></p>
<p class="body-textb1"><b>Radiodifusão Portuguesa</b></p>
<p class="hangb1">Av. Duarte Pacheco, no.5-4<br/>Lisbon, Portugal</p>
<p class="body-textb1">D. <b>Rahter [13, 17]</b></p>
<p class="body-textb1">Basil <b>Ramsey [13]</b></p>
<p class="hangb1">604 Rayleigh Road<br/>Eastwood Leigh-on-Sea<br/>Essex SS9 5HU<br/>United Kingdom<br/>Tel: (44) 1702-524305</p>
<p class="hangb1">Fax: (44) 1702-526142</p>
<p class="body-textb1"><b>Raptus</b> Edition</p>
<p class="hangb1">P.O. Box 3698</p>
<p class="hangb1">Amsterdam, The Netherlands</p>
<p class="body-textb1"><b>Recital Publications [6]</b></p>
<p class="hangb1">P.O. Box 1697<br/>Huntsville, TX 77342-1697</p>
<p class="hangb1">Tel/Fax: (936) 295-6929<br/><a href="http://www.recitalpublications.com" target="_blank">www.recitalpublications.com</a></p>
<p class="body-textb1"><b>Redcliffe</b> Edition</p>
<p class="hangb1">68 Barrowgate Road<br/>London W4 4HD<br/>United Kingdom<br/>Tel: (020) 8995-1223</p>
<p class="body-textb1"><b>Remick</b> Music Corp. <b>[1]</b></p>
<p class="body-textb1"><b>Reuter &amp; Reuter</b> Forlags</p>
<p class="hangb1">P.O. Box 55755</p>
<p class="hangb1">11483 Stockholm, Sweden</p>
<p class="hangb1">Tel: (46) 86-29-53-70</p>
<p class="body-textb1">G. <b>Ricordi</b> &amp; Co. (International) <b>[2, 6, 13, 10, 17]</b></p>
<p class="hangb1">Via Benigno Crespi, 19</p>
<p class="hangb1">20159 Milan, Italy</p>
<p class="hangb1">Tel: (39) 2-80282-811</p>
<p class="hangb1">Fax: (39) 2-80282-882<br/><a href="http://www.ricordi.com" target="_blank">www.ricordi.com</a></p>
<p class="body-textb1"><b>Ricordi Americana</b> (<i>see</i> ALMA, Inc., and G. Ricordi &amp; Co.) <b>[6, 13, 17]</b></p>
<p class="body-textb1"><b>Ricordi BA</b> (Argentina) <b>[6, 13, 17]</b></p>
<p class="body-textb1"><b>Ricordi BR</b> (Brazil) (<i>see</i> ALMA, Inc.) <b>[6, 13, 17]</b></p>
<p class="body-textb1"><b>Ries &amp; Erler</b> (Germany) <b>[6, 7, 17]</b></p>
<p class="hangb1">Wandalenalle 8</p>
<p class="hangb1">14052 Berlin, Germany</p>
<p class="hangb1">Tel: (49) 30-825-10-49</p>
<p class="hangb1">Fax: (49) 30-825-97-21<br/><a href="http://www.rieserler.de" target="_blank">www.rieserler.de</a></p>
<p class="body-textb1"><b>Robbins</b> Music <b>[1]</b></p>
<p class="body-textb1"><b>Roberton</b> Publications <b>[13]</b></p>
<p class="hangb1">Aylesbury, United Kingdom</p>
<p class="body-textb1">Winthrop <b>Rogers</b> Edition <b>[2]</b></p>
<p class="body-textb1"><b>Romcan</b> Publications</p>
<p class="hangb1">115 Orange Street<br/>Beaufort, NC 28516<br/>Tel: (252) 728-2542</p>
<p class="body-textb1"><b>Rongwen</b> Music <b>[2, 17]</b></p>
<p class="body-textb1">E. <b>Rouart, Lerolle &amp; Co.</b> (<i>see</i> Salabert)</p>
<p class="body-textb1"><b>Rozsavölgi [17]</b></p>
<p class="hangb1">Budapest, Hungary</p>
<p class="body-textb1"><b>Russian Music Publishers [17]</b></p>
<p class="hangb1">P.O. Box 49 ‘RMP’<br/>Moscow 105120, Russia</p>
<p class="hangb1">Tel: (7) 495-928-0571</p>
<p class="hangb1">Fax: (7) 495-911-3132<br/><a href="http://www.rmi.ru" target="_blank">www.rmi.ru</a></p>
<p class="body-textb1">Editions <b>Salabert [2, 6, 8, 10, 13, 17]</b></p>
<p class="hangb1">Paris, France<br/><a href="http://www.durand-salabert-eschig.com" target="_blank">www.durand-salabert-eschig.com</a></p>
<p class="body-textb1"><b>Samfundet:</b> Society for the Publication of Danish Music <b>[17]</b></p>
<p class="hangb1">Gråbrødrestræde 18, 1</p>
<p class="hangb1">1156 Copenhagen K, Denmark</p>
<p class="hangb1">Tel: (45) 33-13-54-45</p>
<p class="hangb1">Fax: (45) 33-93-30-44<br/><a href="http://www.samfundet.dk" target="_blank">www.samfundet.dk</a></p>
<p class="body-textb1"><b>San Andreas</b> Press</p>
<p class="hangb1">P.O. Box 60247<br/>Palo Alto, CA 94306</p>
<p class="hangb1">Tel: (650) 856-9394<br/><a href="http://www.scoremus.com" target="_blank">www.scoremus.com</a></p>
<p class="body-textb1"><b>Sassetti</b> &amp; Cia.</p>
<p class="hangb1">R. Nova do Almada, 60<br/>Lisbon 2, Portugal</p>
<p class="body-textb1">J. S. <b>Sato,</b> Music Editions</p>
<p class="hangb1">P.O. Box 14854<br/>Chicago, IL 60614-0854</p>
<p class="hangb1">Tel: (773) 296-0893</p>
<p class="hangb1">Fax: (773) 296-0936<br/><a href="http://www.satomusic.com" target="_blank">www.satomusic.com</a></p>
<p class="body-textb1"><b>Scala Aretina</b></p>
<p class="hangb1">Ediciones Musicales<br/>Apartado de Correos 175</p>
<p class="hangb1">25230 Mollerussa, Spain</p>
<p class="body-textb1">Richard <b>Schauer</b></p>
<p class="hangb1">London, United Kingdom</p>
<p class="body-textb1"><b>Schaum</b> Publications, Inc. <b>[1, 13, 17]</b></p>
<p class="hangb1">10235 North Port Washington Rd.<br/>Mequon, WI 53092</p>
<p class="hangb1">Tel: (800) 786-5023 or (262) 241-5013</p>
<p class="hangb1">Fax: (262) 241-1063<br/><a href="http://www.schaumpiano.com" target="_blank">www.schaumpiano.com</a></p>
<p class="body-textb1"><b>’Schlesinger'sche</b> Musikhandlung <b>[18]</b></p>
<p class="hangb1">Berlin, Germany</p>
<p class="body-textb1">Arthur P. <b>Schmidt</b> Co. <b>[1]</b> (see Summy-Birchard)</p>
<p class="body-textb1"><b>Schott</b> Music International <b>[6, 8, 10, 11, 13, 17]</b></p>
<p class="hangb1">254 W. 31st Street<br/>New York, NY 10001</p>
<p class="hangb1">Tel: (212) 461-6940</p>
<p class="hangb1">Fax: (212) 810-4564<br/><a href="http://www.schott-music.com" target="_blank">www.schott-music.com</a></p>
<p class="body-textb1"><b>Schott</b> Frères (<i>see</i> Schott Music Internationa) <b>[13, 17]</b></p>
<p class="body-textb1"><b>Schroeder &amp; Gunther [10, 13, 17]</b></p>
<p class="body-textb1"><b>Schultheiss</b> Musikverlag, C.L. <b>[18]</b></p>
<p class="hangb1">Tübingen, Germany</p>
<p class="body-textb1"><b>Schultz</b> Music Publications</p>
<p class="hangb1">5637 Beacon Street<br/>Pittsburgh, PA 15217<br/><a href="http://www.schultzmusic.com" target="_blank">www.schultzmusic.com</a></p>
<p class="body-textb1"><b>Schwann</b> Musikverlag <b>[14]</b></p>
<p class="body-textb1"><b>Scottish Music Centre</b></p>
<p class="hangb1">City Halls, Candleriggs<br/>Glasgow G1 1NQ<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 141-552-5222</p>
<p class="hangb1">Fax: (44) 141-553-2789<br/><a href="http://www.scottishmusiccentre.com" target="_blank">www.scottishmusiccentre.com</a></p>
<p class="body-textb1">Charles <b>Scribner</b>'s Sons</p>
<p class="hangb1">c/o Simon &amp; Schuster<br/><a href="http://www.simonandschuster.com" target="_blank">www.simonandschuster.com</a></p>
<p class="body-textb1"><b>Seda Productions</b> (<i>see</i> Seda Publications)</p> <p class="body-textb1"><b>Seda Publications</b></p>
<p class="hangb1">45 Common Street<br/>Belmont, MA 02478-3022</p>
<p class="hangb1">Tel: (617) 489-1848</p>
<p class="hangb1">Fax: (617) 489-6474</p>
<p class="body-textb1"><b>Seesaw</b> Music Corp. (<i>see</i> Subito Music) <b>[17]</b></p>
<p class="body-textb1">Maurice <b>Senart</b> (<i>see</i> Salabert)</p>
<p class="body-textb1"><b>Servico de Documentacao Musical</b></p>
<p class="hangb1">da Ordem dos Musicos do Brasil<br/>Av. Almte. Barroso, 72-7 Andar<br/>Rio de Janeiro, Brazil</p>
<p class="body-textb1"><b>Shawnee</b> Press <b>[10, 13, 17]</b></p>
<p class="hangb1">Tel: (800) 962-8584<br/><a href="http://www.shawneepress.com" target="_blank">www.shawneepress.com</a></p>
<p class="body-textb1"><b>Sikesdi Press</b></p>
<p class="hangb1">1102 Bellevue Avenue SE<br/>Calgary, Alberta T2G 4LI, Canada</p>
<p class="hangb1">Fax: (403) 262-1201</p>
<p class="body-textb1">Hans <b>Sikorski [6, 8, 10, 13, 16, 17]</b></p>
<p class="hangb1">Johnsallee 23</p>
<p class="hangb1">20148 Hamburg, Germany</p>
<p class="hangb1">Tel: (49) 40 41 41 00 0</p>
<p class="hangb1">Fax: (49) 40 41 41 00 40</p>
<p class="hangb1"><a href="http://www.sikorski.de" target="_blank">www.sikorski.de</a></p>
<p class="body-textb1">N. <b>Simrock [2, 6, 10, 13, 17]</b></p>
<p class="hangb1">Berlin, Germany</p>
<p class="body-textb1"><b>Sisra</b> Publications (<i>see</i> Arsis Press)</p>
<p class="body-textb1"><b>Skandinavisk</b> Musikförlag</p>
<p class="hangb1"><a href="http://www.nodelageret.dk" target="_blank">www.nodelageret.dk</a></p>
<p class="body-textb1"><b>Skandinavisk</b> og Borups Musikförlag <b>[18]</b></p>
<p class="hangb1">Copenhagan, Denmark</p>
<p class="body-textb1"><b>Smith</b> Publications/Sonic Art Editions</p>
<p class="hangb1">54 Lent Road<br/>Sharon, VT 05065<br/>Tel: (802) 765-4714<br/><a href="http://www.smith-publications.com" target="_blank">www.smith-publications.com</a></p>
<p class="body-textb1"><b>Société des Nouvelles Editions Liègeoises</b></p>
<p class="hangb1">(<i>see</i> Mardaga)</p>
<p class="body-textb1"><b>Société Française de Musicologie [17]</b> (<i>see</i> Minkoff)</p>
<p class="body-textb1"><b>Société Liègeoise de Musicologie</b></p>
<p class="hangb1">Rue Curtius, 11</p>
<p class="hangb1">4020 Liège, Belgium</p>
<p class="hangb1">Tel: (32) 4-366-58-50<br/><a href="http://www.slgm.ulg.ac.be" target="_blank">www.slgm.ulg.ac.be</a></p>
<p class="body-textb1">Fundación Vincente Emilio <b>Sojo</b></p>
<p class="hangb1">Avenida Santiago de Chile<br/>No. 17, Los Caebos<br/>Apartado Postal 70537<br/>Caracas 1071, Venezuela</p>
<p class="hangb1">Tel: (58) 2-793-57-17 or (58) 2-793-49-48</p>
<p class="hangb1">Fax: (58) 2-793-59-82</p>
<p class="body-textb1"><b>Sonos</b> Music Resources <b>[17]</b></p>
<p class="body-textb1"><b>Soundings</b> Press</p>
<p class="hangb1">948 Canyon Road<br/>Sante Fe, NM 87501</p>
<p class="body-textb1">The <b>Southern Baptist Theological Seminary</b></p>
<p class="hangb1">James P. Boyce Library<br/>2825 Lexington Road<br/>Louisville, KY 40280</p>
<p class="hangb1">Tel: (502) 897-4713<br/><a href="http://www.library.sbts.edu" target="_blank">www.library.sbts.edu</a></p>
<p class="body-textb1"><b>Southern</b> Music Publishing <b>[10, 17]</b></p>
<p class="hangb1">P.O. Box 329<br/>San Antonio, TX 78292</p>
<p class="hangb1">Tel: (210) 226-8167</p>
<p class="hangb1">Fax: (210) 223-4537<br/><a href="http://www.southernmusic.com" target="_blank">www.southernmusic.com</a></p>
<p class="body-textb1"><b>Soviet Composers / Sovetskii Kompozitor</b></p>
<p class="hangb1">Moscow, Russia</p>
<p class="body-textb1">Leo <b>Sowerby</b> Foundation <b>[13, 15, 17]</b></p>
<p class="hangb1">2 Congress Street<br/>Worcester, MA 01609-2003</p>
<p class="hangb1">Tel: (508) 755-7906</p>
<p class="body-textb1"><b>Special Music Edition</b></p>
<p class="hangb1">Maur, Switzerland</p>
<p class="body-textb1"><b>Stainer &amp; Bell [5, 6, 17]</b></p>
<p class="hangb1">P.O. Box 110, Victoria House<br/>23 Gruneisen Road<br/>London N3 1DZ<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 20-8343-3303</p>
<p class="hangb1">Fax: (44) 20-8343-3024<br/><a href="http://www.stainer.co.uk" target="_blank">www.stainer.co.uk</a></p>
<p class="body-textb1">Thomas C. <b>Stangland [17]</b></p>
<p class="hangb1">P.O. Box 19263<br/>Portland, OR 97280-0263</p>
<p class="hangb1">Tel: (503) 244-0634</p>
<p class="hangb1">Fax: (208) 485-4393</p>
<p class="body-textb1"><b>Stat hudbeni vydavateiski</b> (<i>see</i> Supraphon)</p>
<p class="body-textb1"><b>Steingräber</b> Verlag</p>
<p class="hangb1"><a href="http://www.steingraeber-musikverlag.de" target="_blank">www.steingraeber-musikverlag.de</a></p>
<p class="body-textb1"><b>Stockhausen</b> Verlag <b>[6]</b></p>
<p class="hangb1">Stockhausen Foundation for Musik<br/>51515 Kürten, Germany</p>
<p class="hangb1">Fax: (49) 2268-1813<br/><a href="http://www.stockhausen.org" target="_blank">www.stockhausen.org</a></p>
<p class="body-textb1"><b>Studio P/R [1]</b></p>
<p class="body-textb1"><b>Subito</b> Music Publishing <b>[2, 17]</b></p>
<p class="hangb1">60 Depot Street<br/>Verona, NJ 07044</p>
<p class="hangb1">Tel: (973) 857-3440</p>
<p class="hangb1">Fax: (973) 857-3442<br/><a href="http://www.subitomusic.com" target="_blank">www.subitomusic.com</a></p>
<p class="body-textb1"><b>Süddeutscher</b> Musikverlag <b>[17]</b></p>
<p class="hangb1">Heidelberg, Germany</p>
<p class="body-textb1"><b>Summy-Birchard [2]</b></p>
<p class="hangb1">15800 NW 48th Avenue<br/>Miami, FL 33014<br/>Tel: (305) 620-1500</p>
<p class="hangb1">Fax: (305) 621-1094</p>
<p class="body-textb1"><b>Supraphon</b></p>
<p class="hangb1">Palackého 1 / 740</p>
<p class="hangb1">112 99 Prague 1, Czech Republic</p>
<p class="hangb1">Tel: (420) 221-966-600</p>
<p class="hangb1">Fax: (420) 221-966-630<br/><a href="http://www.supraphon.com" target="_blank">www.supraphon.com</a></p>
<p class="body-textb1"><b>Swan</b> &amp; Co. (England) <b>[18]</b></p>
<p class="hangb1">London, United Kingdom</p>
<p class="body-textb1"><b>Templeton</b> Publishing Co. (<i>see</i> Shawnee Press)</p>
<p class="body-textb1"><b>Tempo</b> Praha/Bote &amp; Bock <b>[15]</b></p>
<p class="hangb1">Berlin, Germany</p>
<p class="body-textb1"><b>Tenuto</b> Publications <b>[13, 15, 17]</b></p>
<p class="hangb1"><a href="http://www.tritone-tenuto.com" target="_blank">www.tritone-tenuto.com</a></p>
<p class="body-textb1"><b>Tetra</b> Music Corp. (<i>see</i> Plymouth Music Co.) <b>[6]</b></p>
<p class="body-textb1"><b>Thames</b> Music Publishing <b>[6, 17]</b></p>
<p class="body-textb1">Gordon V. <b>Thompson [1]</b></p>
<p class="hangb1">29 Birch Avenue<br/>M4V 1E2 Toronto, Canada</p>
<p class="hangb1">Tel: (416) 227-0566</p>
<p class="hangb1">Fax: (416) 227-0573</p>
<p class="body-textb1"><b>Thorpe</b> Music Publishing <b>[13, 15, 17]</b></p>
<p class="hangb1"><a href="http://www.thorpemusic.com" target="_blank">www.thorpemusic.com</a></p>
<p class="body-textb1">P. J. <b>Tonger [17]</b></p>
<p class="hangb1">Haid-und-Neu-Straße 18</p>
<p class="hangb1">76131 Karlsruhe, Germany</p>
<p class="hangb1">Tel: (49) 721-62-68-56-6 or</p>
<p class="hangb1">(49) 221-93-55-64-0</p>
<p class="hangb1"><a href="http://www.tonger.de" target="_blank">www.tonger.de</a></p>
<p class="body-textb1"><b>Tonos</b> Musikverlags <b>[6, 17]</b></p>
<p class="hangb1">Lange Straße 89a<br/>76530 Baden-Baden, Germany<br/>Tel: (49) 7221 97370 0</p>
<p class="hangb1">Fax: (49) 7221 97370 27<br/><a href="http://www.tonosmusic.com" target="_blank">www.tonosmusic.com</a></p>
<p class="body-textb1"><b>To-oN Kikau</b> Co.</p>
<p class="hangb1">1-15-1 Sugamo<br/>Toshima-ku<br/>Tokyo, Japan 170<br/>Tel: (81-3) 39441581</p>
<p class="hangb1">Fax: (81-3) 39442130</p>
<p class="body-textb1">Ediziun <b>Trais Giats</b></p>
<p class="hangb1">7546 Ardez, Switzerland<br/>Tel/Fax: (41) 81-862-22-34<br/> <a href="http://www.trais-giats.ch" target="_blank">www.trais-giats.ch</a></p>
<p class="body-textb1"><b>Transcontinental</b> Music Publications/New Jewish Music Press <b>[17]</b></p>
<p class="hangb1">URJ Books &amp; Music<br/>633 Third Avenue, 7th Floor<br/>New York, NY 10017-6778</p>
<p class="hangb1">Tel: (212) 650-4120</p>
<p class="hangb1">Fax: (212) 650-4119<br/><a href="http://www.transcontinentalmusic.com" target="_blank">www.transcontinentalmusic.com</a></p>
<p class="body-textb1"><b>Tre Media</b> Musikverlage</p>
<p class="hangb1">Friederike Zimmermann<br/>Amalienstrasse 40<br/>76133 Karlsruhe, Germany</p>
<p class="hangb1">Tel: (49) 721-26023</p>
<p class="hangb1">Fax: (49) 721-26044<br/><a href="http://www.tremediamusicedition.de" target="_blank">www.tremediamusicedition.de</a></p>
<p class="body-textb1"><b>Tritó [6, 17]</b></p>
<p class="hangb1">Enamorats, 35-37 baixos<br/>08013 Barcelona, Spain</p>
<p class="hangb1">Tel: (34) 933-426-175</p>
<p class="hangb1">Fax: (34) 933-022-670<br/><a href="http://www.trito.es" target="_blank">www.trito.es</a></p>
<p class="body-textb1">Editorial <b>Tritone [18]</b></p>
<p class="hangb1">Lima, Peru</p>
<p class="body-textb1"><b>Unión Musical Ediciones [6, 10, 13, 16, 17]</b></p>
<p class="hangb1">(part of Music Sales Group)<br/>Marqués de la Ensenada, 4<br/>28004 Madrid, Spain</p>
<p class="hangb1">Tel: (34) 91-308-4040</p>
<p class="hangb1">Fax: (34) 91-310-4429<br/><a href="http://unionmusicalediciones.com" target="_blank">unionmusicalediciones.com</a></p>
<p class="body-textb1"><b>Unión Musical Española [16]</b></p>
<p class="hangb1">Carrera de San Jerónimo, 26<br/>28014 Madrid, Spain</p>
<p class="hangb1">Tel: (34) 902-112-859<br/><a href="http://www.unionmusical.es" target="_blank">www.unionmusical.es</a></p>
<p class="body-textb1"><b>United</b> Music Publishers <b>[13, 15, 17]</b></p>
<p class="hangb1">3 Abbey Point<br/>Cartersfield Road<br/>Waltham Abbey<br/>Essex EN9 1FE<br/>United Kingdom</p>
<p class="hangb1">Tel: (44) 1992-703110</p>
<p class="hangb1">Fax: (44) 1992-767682<br/><a href="http://www.ump.co.uk" target="_blank">www.ump.co.uk</a></p>
<p class="body-textb1"><b>Universal Edition [6, 8, 13, 15, 17]</b></p>
<p class="hangb1">Karlsplatz 6<br/>1010 Vienna, Austria</p>
<p class="hangb1">Tel: (43) 1-337-23-0</p>
<p class="hangb1">Fax: (43) 1-337-23-400<br/><a href="http://www.universaledition.com" target="_blank">www.universaledition.com</a></p>
<p class="body-textb1"><b>Universal Music</b> Publishing Group</p>
<p class="hangb1">2100 Colorado Avenue<br/>Santa Monica, CA 90404<br/>Tel: (310) 235-4700</p>
<p class="hangb1">Fax: (310) 235-4900<br/><a href="http://www.umusicpub.com" target="_blank">www.umusicpub.com</a></p>
<p class="body-textb1"><b>University of California Press</b></p>
<p class="hangb1">2120 Berkeley Way<br/>Berkeley, CA 94704<br/>Tel: (800) 777-4726 (orders) or</p>
<p class="hangb1">(510) 642-4247</p>
<p class="hangb1">Fax: (510) 643-7127<br/><a href="http://www.ucpress.edu" target="_blank">www.ucpress.edu</a></p>
<p class="body-textb1"><b>University of Washington Press</b></p>
<p class="hangb1">P.O. Box 50096<br/>Seattle, WA 98145</p>
<p class="hangb1">Tel: (800) 537-5487 (orders)<br/>or (206) 543-4050</p>
<p class="hangb1">Fax: (206) 543-3932<br/><a href="http://www.washington.edu/uwpress" target="_blank">www.washington.edu/uwpress</a></p>
<p class="body-textb1"><b>University of Virginia Press</b></p>
<p class="hangb1">P.O. Box 400318<br/>Charlottesville, VA 22904</p>
<p class="hangb1">Tel: (800) 831-3406</p>
<p class="hangb1">Fax: (877) 288-6400<br/><a href="http://www.upress.virginia.edu" target="_blank">www.upress.virginia.edu</a></p>
<p class="body-textb1"><b>University Society</b> Publishers</p>
<p class="hangb1">145 N. Franklin Turnpike<br/>Ramsey, NJ 07446</p>
<p class="hangb1">Tel: (201) 327-1982</p>
<p class="body-textb1"><b>Urbanek</b> (<i>see</i> Artia)</p>
<p class="body-textb1"><b>Ut Orpheus</b> Edizioni <b>[6, 17]</b></p>
<p class="hangb1">Piazza di Porta Ravegnana 1</p>
<p class="hangb1">40126 Bologna, Italy</p>
<p class="hangb1">Tel: (39) 051-226468</p>
<p class="hangb1">Fax: (39) 051-263720<br/><a href="http://www.utorpheus.com" target="_blank">www.utorpheus.com</a></p>
<p class="body-textb1"><b>Valley</b> Music Press</p>
<p class="hangb1">Northampton, MA<br/><a href="http://www.valleymusicpress.com" target="_blank">www.valleymusicpress.com</a></p>
<p class="body-textb1"><b>Van Rossum</b> (Netherlands) <b>[18]</b></p>
<p class="body-textb1"><b>Vereniging voor Nederlandse</b></p>
<p class="hangb1"><b>Muziekgeschiedenis</b> (Dutch Society for Musicology)<br/>Postbus 1514<br/>3500 BM Utrecht<br/>The Netherlands<br/><a href="http://www.kvnm.nl" target="_blank">http://www.kvnm.nl</a></p>
<p class="body-textb1"><b>Verlag für Musikalische Kultur und Wissenschaft</b></p>
<p class="hangb1">Wolfenbüttel, Germany</p>
<p class="body-textb1"><b>Verlag Neue Musik</b></p>
<p class="hangb1">Grabbeallee 15</p>
<p class="hangb1">13156 Berlin, Germany</p>
<p class="hangb1">Tel: (49) 30 61 69 81 0</p>
<p class="hangb1">Fax: (49) 30 61 69 81 21<br/><a href="http://www.verlag-neue-musik.de" target="_blank">www.verlag-neue-musik.de</a></p>
<p class="body-textb1"><b>Vienna Masterworks</b> (BMI)</p>
<p class="hangb1">Margaretenstrasse 125/15<br/>1050 Vienna, Austria</p>
<p class="body-textb1"><b>Vienna Urtext</b> Editions <b>[13, 15, 17]</b></p>
<p class="hangb1">Forsthausgasse 9<br/>1200 Vienna, Austria</p>
<p class="hangb1">Tel: (43) 1-33723-226</p>
<p class="hangb1">Fax: (43) 1-33723-425<br/><a href="http://www.wiener-urtext.com" target="_blank">www.wiener-urtext.com</a></p>
<p class="body-textb1">Musikverlag C. F. <b>Vieweg [18]</b></p>
<p class="body-textb1"><b>Viking</b> Musikförlag</p>
<p class="hangb1">Lille Strandvej 3</p>
<p class="hangb1">2900 Hellerup<br/>Copenhagen, Denmark</p>
<p class="hangb1">Tel: (45) 31-62-12-10</p>
<p class="body-textb1"><b>Visible</b> Music</p>
<p class="hangb1">1037 Park Avenue<br/>Amherst, OH 44001<br/>Tel: (440) 984-4037<br/><a href="http://www.visible-music.com" target="_blank">www.visible-music.com</a></p>
<p class="body-textb1">Irmãos <b>Vitale</b></p>
<p class="hangb1">Rua França Pinto, 42<br/>São Paulo, Brazil</p>
<p class="hangb1">Tel: (11) 5081-9499</p>
<p class="hangb1">Fax: (11) 5574-7388<br/><a href="http://www.vitale.com.br" target="_blank">www.vitale.com.br</a></p>
<p class="body-textb1"><b>Vivace</b> Press <b>[6, 17]</b></p>
<p class="hangb1">University of Missouri<br/>1 University Boulevard<br/>265 General Services Building</p>
<p class="hangb1">Tel: (314) 516-4990</p>
<p class="hangb1">Fax: (314) 516-4992<br/><a href="http://www.vivacepress.com" target="_blank">www.vivacepress.com</a></p>
<p class="body-textb1">Arno <b>Volk</b> Verlag (<i>see</i> Universal Music Publishing Group)</p>
<p class="body-textb1">Edition <b>Walhall</b> / Verlag Franz Biersack <b>[17]</b></p>
<p class="hangb1">Richard-Wagner Straße 3</p>
<p class="hangb1">39106 Magdeburg, Germany</p>
<p class="hangb1">Tel: (49) 391-85-78-20</p>
<p class="hangb1">Fax: (49) 391-8-52-00-79<br/><a href="http://www.edition-walhall.de" target="_blank">www.edition-walhall.de</a></p>
<p class="body-textb1"><b>Walton</b> Music <b>[2, 6, 10, 13, 17]</b></p>
<p class="hangb1">1028 Highland Woods Rd.<br/>Chapel Hill, NC 27517</p>
<p class="hangb1">Tel: (919) 929-1330</p>
<p class="hangb1">Fax: (919) 929-2232<br/><a href="http://www.waltonmusic.com" target="_blank">www.waltonmusic.com</a></p>
<p class="body-textb1"><b>Warner Brothers</b> Publications <b>[1, 13]</b></p>
<p class="body-textb1"><b>Warner/Chappell</b> Music</p>
<p class="hangb1">10585 Santa Monica Boulevard<br/>Los Angeles, CA 90025-4950</p>
<p class="hangb1">Tel: (310) 441-8600</p>
<p class="hangb1">Fax: (310) 441-8780<br/><a href="http://www.warnerchappell.com" target="_blank">www.warnerchappell.com</a></p>
<p class="body-textb1"><b>Waterloo</b> Music Co. <b>[4]</b></p>
<p class="body-textb1">Carlo <b>Wehrs</b></p>
<p class="hangb1">Ac/de Eulenstein Musica S.A.<br/>Rua Rute Ferreira, 258<br/>(ZC-22-Ramos)<br/>20000 Rio de Janeiro, Brazil</p>
<p class="body-textb1">Josef <b>Weinberger [2, 6, 10, 13, 17]</b></p>
<p class="hangb1">12-14 Mortimer Street<br/>London W1T 3JJ, Great Britain<br/>Tel: (44) 20-7580-2827</p>
<p class="hangb1">Fax: (44) 20-7436-9616<br/><a href="http://www.josef-weinberger.com" target="_blank">www.josef-weinberger.com</a></p>
<p class="body-textb1"><b>Weintraub</b> Music <b>[16, 17]</b></p>
<p class="body-textb1"><b>Westerlund [18]</b></p>
<p class="hangb1">Helsinki, Finland</p>
<p class="body-textb1"><b>Western International Music</b></p>
<p class="hangb1">3707 65th Avenue<br/>Greeley, CO 80634</p>
<p class="hangb1">Tel: (970) 330-6901</p>
<p class="hangb1">Fax: (970) 330-7738<br/><a href="http://www.wiminc.com" target="_blank">www.wiminc.com</a></p>
<p class="body-textb1"><b>Western Music,</b> Ltd. (Canada) <b>[18]</b></p>
<p class="body-textb1">Joseph <b>Williams</b> Editions (England) <b>[18]</b></p>
<p class="body-textb1"><b>Willis</b> Music Co. <b>[10, 13, 17]</b></p>
<p class="hangb1">7380 Industrial Road</p>
<p class="hangb1">P.O. Box 548<br/>Florence, KY 41042</p>
<p class="hangb1">Tel: (800) 354-9799 or (859) 283-2050</p>
<p class="hangb1">Fax: (859) 283-1784<br/><a href="http://www.willismusic.com" target="_blank">www.willismusic.com</a></p>
<p class="body-textb1"><b>Wimbledon</b> Music</p>
<p class="hangb1">Trigram Music Inc./Wimbledon Music <b>[17]</b></p>
<p class="hangb1">1801 Century Park East, Suite 2400<br/>Los Angeles, CA 90067</p>
<p class="hangb1">Tel: (310) 556-9683</p>
<p class="hangb1">Fax: (310) 277-1278<br/><a href="http://www.wimbtri.net" target="_blank">www.wimbtri.net</a></p>
<p class="body-textb1"><b>Witmark &amp; Sons [18]</b></p>
<p class="body-textb1">Walter <b>Wollenweber</b> Verlag <b>[14]</b></p>
<p class="hangb1">Munich, Germany</p>
<p class="body-textb1"><b>Yorktown</b> Music Press <b>[10, 13, 17]</b></p>
<p class="body-textb1">G. <b>Zanibon [10, 13, 17]</b></p>
<p class="body-textb1">c/o <b>Armelin</b> Musica</p>
<p class="hangb1">Via dei Soncin, 42<br/>35122 Padova, Italy</p>
<p class="hangb1">Tel: (39) 49-8724-928</p>
<p class="hangb1">Fax: (39) 49-8736-524<br/><a href="http://www.zanibon.it" target="_blank">www.zanibon.it</a></p>
<p class="body-textb1"><b>Zen-on</b> Music Co. <b>[6, 10, 11, 13, 17]</b></p>
<p class="hangb1">2-13-3 Kami Ochiai<br/>Shinjuku-ku, Tokyo 161-0034<br/>Japan<br/>Tel: (81) 3-3227-6283</p>
<p class="hangb1">Fax: (81) 3-3227-6288<br/><a href="http://www.zen-on.co.jp" target="_blank">www.zen-on.co.jp</a></p>
<p class="body-textb1"><b>Zenmükiado</b> Vallalat (<i>see</i> Editio Musica <b>Budapest EMB)</b></p>
<p class="body-textb1">Éditions du <b>Zephyr [18]</b></p>
<p class="hangb1">Brussels, Belgium</p>
<p class="body-textb1">Edizioni Suvini <b>Zerboni [2, 6, 17]</b></p>
<p class="hangb1">Galleria del Corso, 4<br/>20122 Milano, Italy</p>
<p class="hangb1">Tel: (39) 2-770701</p>
<p class="hangb1">Fax: (39) 2-77070261<br/><a href="http://www.esz.it" target="_blank">www.esz.it</a></p>
<p class="body-textb1">Wilhelm <b>Zimmermann</b> Musikverlag <b>[6, 14, 17]</b></p>
<p class="hangb1">Tel: (49) 69-978286-6</p>
<p class="hangb1">Fax: (49) 69-978286-79<br/>Frankfurt, Germany<br/><a href="http://www.zimmermann-frankfurt.de" target="_blank">www.zimmermann-frankfurt.de</a></p>
<p class="body-textb1">Editions Aug. <b>Zurfluh [6, 13, 17]</b></p>
<p class="hangb1">13, Avenue du Lycée Lakanal<br/>92340 Bourg-la-Reine, France</p>
<p class="hangb1">Tel: (33) 1-46-60-50-28</p>
<p class="hangb1">Fax: (33) 1-46-61-52-30<br/><a href="http://www.editions-aug-zurfluh.fr" target="_blank">www.editions-aug-zurfluh.fr</a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// address.vue?9118e112